<template>
  <div class="admin-page">
    <div v-if="!isLoggedIn" class="login-form">
      <h2>Přihlášení do administrace</h2>
      <form @submit.prevent="login">
        <div class="mb-3">
          <label for="username" class="form-label">Uživatelské jméno</label>
          <input type="text" class="form-control" id="username" v-model="loginForm.username" required>
        </div>
        <div class="mb-3">
          <label for="password" class="form-label">Heslo</label>
          <input type="password" class="form-control" id="password" v-model="loginForm.password" required>
        </div>
        <button type="submit" class="btn btn-primary">Přihlásit</button>
      </form>
    </div>

    <div v-else>
      <div class="d-flex justify-content-between align-items-center mb-3">
      <h2>Administrace</h2>
        <button class="btn btn-outline-light" @click="logout">Odhlásit se</button>
      </div>
      
      <!-- Tabs -->
      <ul class="nav nav-tabs mb-4">
        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'teams' }" @click="activeTab = 'teams'" href="#">
            Týmy
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'players' }" @click="activeTab = 'players'" href="#">
            Hráči
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'seasons' }" @click="activeTab = 'seasons'" href="#">
            Ročníky
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'matches' }" @click="activeTab = 'matches'" href="#">
            Zápasy
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'results' }" @click="activeTab = 'results'" href="#">
            Výsledky zápasů
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'sponsors' }" @click="activeTab = 'sponsors'" href="#">
            Sponzoři
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'dk' }" @click="activeTab = 'dk'" href="#">
            DK
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'league-management' }" @click="activeTab = 'league-management'" href="#">
            Vedení ligy
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'team-managers' }" @click="activeTab = 'team-managers'" href="#">
            Vedoucí týmů
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'playoff-bracket' }" @click="activeTab = 'playoff-bracket'" href="#">
            Playoff pavouk
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'news' }" @click="activeTab = 'news'" href="#">
            Aktuality
          </a>
        </li>
      </ul>

      <!-- Teams management -->
      <div v-if="activeTab === 'teams'" class="tab-content">
        <h3>Přidat nový tým</h3>
        <form @submit.prevent="addTeam" class="mb-4">
          <div class="mb-3">
            <label for="teamName" class="form-label">Název týmu</label>
            <input type="text" class="form-control" id="teamName" v-model="newTeam.name" required>
          </div>
          <div class="mb-3">
            <label class="form-label">Logo týmu</label>
            <div class="d-flex gap-2 align-items-center">
              <div v-if="newTeam.logoPreview" class="logo-preview me-2">
                <img :src="getLogoUrl(newTeam.logoPreview)" alt="Náhled loga" style="height: 48px; width: auto;">
              </div>
              <button type="button" class="btn btn-secondary" @click="showLogoSelectionModal('new')">
                {{ newTeam.logo ? 'Změnit logo' : 'Vybrat logo' }}
              </button>
              <input type="file" class="d-none" ref="teamLogoInput" @change="handleLogoUpload" accept="image/*">
              <button type="button" class="btn btn-outline-secondary" @click="triggerFileInput('new')">
                Nahrát nové logo
              </button>
              <button v-if="newTeam.logo || newTeam.logoPreview" type="button" class="btn btn-outline-danger" @click="clearTeamLogo('new')">
                Odstranit logo
              </button>
            </div>
            <small class="form-text text-muted">Povolené formáty: JPEG, PNG, GIF (max 5MB)</small>
          </div>
          <button type="submit" class="btn btn-primary">Přidat tým</button>
        </form>
        <h3>Seznam týmů</h3>
        <table class="table">
          <thead>
            <tr>
              <th>Název</th>
              <th>Logo</th>
              <th>Akce</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="team in teams" :key="team.id">
              <td>
                <span v-if="editTeamId !== team.id">{{ team.name }}</span>
                <input v-else v-model="editTeam.name" class="form-control" />
              </td>
              <td>
                <template v-if="editTeamId !== team.id">
                  <img v-if="team.logo" :src="getLogoUrl(team.logo)" alt="logo" style="height:32px;" />
                  <span v-else class="text-dimmed" style="font-size: 0.9em;">bez loga</span>
                </template>
                <template v-else>
                  <div class="d-flex gap-2 align-items-center">
                    <div v-if="editTeam.logoPreview || team.logo" class="logo-preview me-2">
                      <img :src="getLogoUrl(editTeam.logoPreview || team.logo)" alt="Náhled loga" style="height: 48px; width: auto;">
                    </div>
                    <button type="button" class="btn btn-sm btn-secondary" @click="triggerFileInput('edit', team.id)">
                      Nahrát nové logo
                    </button>
                    <button v-if="editTeam.logo || editTeam.logoPreview || team.logo" type="button" class="btn btn-sm btn-outline-danger" @click="deleteTeamLogo(team.id)">
                      Odstranit logo
                    </button>
                    <input type="file" class="d-none" :ref="el => { if (el) editTeamLogoInputs[team.id] = el }" @change="handleEditLogoUpload" accept="image/*">
                  </div>
                </template>
              </td>
              <td>
                <button v-if="editTeamId !== team.id" class="btn btn-sm btn-warning me-2" @click="startEditTeam(team)">Upravit</button>
                <button v-else class="btn btn-sm btn-success me-2" @click="saveEditTeam(team.id)">Uložit</button>
                <button v-if="editTeamId === team.id" class="btn btn-sm btn-secondary me-2" @click="cancelEditTeam">Zrušit</button>
                <button class="btn btn-sm btn-danger" @click="deleteTeam(team.id)">Smazat</button>
              </td>
            </tr>
          </tbody>
        </table>
        <pre>{{ teams }}</pre>
      </div>

      <!-- Players management -->
      <div v-if="activeTab === 'players'" class="tab-content">
        <h3>Správa hráčů</h3>
        <div class="mb-4">
          <div class="row">
            <div class="col-md-6">
              <h4>Přidat jednotlivého hráče</h4>
              <form @submit.prevent="addPlayer" class="mb-4">
                <div class="mb-3">
                  <label for="playerTeam" class="form-label">Tým</label>
                  <select class="form-select" id="playerTeam" v-model="newPlayer.team_id" required>
                    <option v-for="team in teams" :key="team.id" :value="team.id">
                      {{ team.name }}
                    </option>
                  </select>
                </div>
                <div class="mb-3">
                  <label for="firstName" class="form-label">Jméno</label>
                  <input type="text" class="form-control" id="firstName" v-model="newPlayer.first_name" required>
                </div>
                <div class="mb-3">
                  <label for="lastName" class="form-label">Příjmení</label>
                  <input type="text" class="form-control" id="lastName" v-model="newPlayer.last_name" required>
                </div>
                <div class="mb-3">
                  <label for="jerseyNumber" class="form-label">Číslo dresu</label>
                  <input type="number" class="form-control" id="jerseyNumber" v-model="newPlayer.jersey_number" required>
                </div>
                <div class="mb-3">
                  <label for="position" class="form-label">Pozice</label>
                  <select class="form-select" id="position" v-model="newPlayer.position">
                    <option value="Útočník">Útočník</option>
                    <option value="Obránce">Obránce</option>
                    <option value="Brankář">Brankář</option>
                  </select>
                </div>
                <div class="mb-3 form-check">
                  <input type="checkbox" class="form-check-input" id="isRegistered" v-model="newPlayer.is_registered">
                  <label class="form-check-label" for="isRegistered">Registrovaný hráč</label>
                </div>
                <button type="submit" class="btn btn-primary">Přidat hráče</button>
              </form>
            </div>
            <div class="col-md-6">
              <h4>Hromadný import hráčů</h4>
              <div class="mb-3">
                <label for="bulkTeam" class="form-label">Tým</label>
                <select class="form-select" id="bulkTeam" v-model="bulkImport.team_id" required>
                  <option v-for="team in teams" :key="team.id" :value="team.id">
                    {{ team.name }}
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label for="csvFile" class="form-label">CSV soubor</label>
                <input type="file" class="form-control" id="csvFile" @change="handleFileUpload" accept=".csv">
                <small class="form-text text-muted">
                  CSV soubor musí obsahovat sloupce: jméno, příjmení, číslo_dresu, pozice, registrovaný
                </small>
              </div>
              <button @click="importPlayers" class="btn btn-primary" :disabled="!bulkImport.file">
                Importovat hráče
              </button>
            </div>
          </div>
        </div>

        <h4>Seznam hráčů</h4>
        <div class="mb-3">
          <label for="teamSelect" class="form-label">Vyberte tým</label>
          <select class="form-select" id="teamSelect" v-model="selectedTeamId" @change="handleTeamSelect($event.target.value)">
            <option v-for="team in teams" :key="team.id" :value="team.id">
              {{ team.name }}
            </option>
          </select>
        </div>
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th>Tým</th>
                <th>Jméno</th>
                <th>Příjmení</th>
                <th>Číslo</th>
                <th>Pozice</th>
                <th>Status</th>
                <th>Volný hráč</th>
                <th>Aktivní</th>
                <th>Poznámka</th>
                <th>Akce</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="player in players" :key="player.id">
                <template v-if="editPlayerId !== player.id">
                  <td>{{ getTeamName(player.team_id) }}</td>
                  <td>{{ player.first_name }}</td>
                  <td>{{ player.last_name }}</td>
                  <td>{{ player.jersey_number }}</td>
                  <td>{{ player.position }}</td>
                  <td>{{ player.is_registered ? 'R' : 'N' }}</td>
                  <td>
                    <span v-if="player.isfreeagent" class="badge bg-warning text-dark">Ano</span>
                    <span v-else class="badge bg-success">Ne</span>
                  </td>
                  <td>
                    <span v-if="player.isactive !== false" class="badge bg-success">Ano</span>
                    <span v-else class="badge bg-secondary">Ne</span>
                  </td>
                  <td>{{ player.note || '--' }}</td>
                  <td>
                    <button class="btn btn-sm btn-warning me-2" @click="startEditPlayer(player)">Upravit</button>
                    <button class="btn btn-sm btn-info me-2" @click="showTransferDialog(player)">Přestup</button>
                    <button class="btn btn-sm btn-secondary me-2" @click="makeFreeAgent(player)" v-if="!player.isfreeagent">Volný hráč</button>
                    <button v-if="player.isactive !== false" class="btn btn-sm btn-danger" @click="deletePlayer(player.id)">Deaktivovat</button>
                    <button v-else class="btn btn-sm btn-success" @click="activatePlayer(player.id)">Aktivovat</button>
                  </td>
                </template>
                <template v-else>
                  <td>
                    <select class="form-select" v-model="editPlayer.team_id">
                      <option v-for="team in teams" :key="team.id" :value="team.id">{{ team.name }}</option>
                    </select>
                  </td>
                  <td><input type="text" class="form-control" v-model="editPlayer.first_name" /></td>
                  <td><input type="text" class="form-control" v-model="editPlayer.last_name" /></td>
                  <td><input type="number" class="form-control" v-model="editPlayer.jersey_number" /></td>
                  <td>
                    <select class="form-select" v-model="editPlayer.position">
                      <option value="Útočník">Útočník</option>
                      <option value="Obránce">Obránce</option>
                      <option value="Brankář">Brankář</option>
                    </select>
                  </td>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" v-model="editPlayer.is_registered">
                    </div>
                  </td>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" v-model="editPlayer.isFreeAgent">
                    </div>
                  </td>
                  <td>
                    <span v-if="editPlayer.isactive !== false" class="badge bg-success">Ano</span>
                    <span v-else class="badge bg-secondary">Ne</span>
                  </td>
                  <td><input type="text" class="form-control" v-model="editPlayer.note" placeholder="Poznámka..." /></td>
                  <td>
                    <button class="btn btn-sm btn-success me-2" @click="saveEditPlayer(player.id)">Uložit</button>
                    <button class="btn btn-sm btn-secondary" @click="cancelEditPlayer">Zrušit</button>
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Seasons management -->
      <div v-if="activeTab === 'seasons'" class="tab-content">
        <h3>Přidat nový ročník</h3>
        <div v-if="successMessage" class="alert alert-success alert-dismissible fade show" role="alert">
          {{ successMessage }}
          <button type="button" class="btn-close" @click="successMessage = ''"></button>
        </div>
        <form @submit.prevent="addSeason" class="mb-4">
          <div class="mb-3">
            <label for="seasonName" class="form-label">Název ročníku</label>
            <input type="text" class="form-control" id="seasonName" v-model="newSeason.name" required>
          </div>
          <div class="mb-3">
            <label for="startDate" class="form-label">Datum začátku</label>
            <input type="date" class="form-control" id="startDate" v-model="newSeason.start_date" required>
          </div>
          <div class="mb-3">
            <label for="endDate" class="form-label">Datum konce</label>
            <input type="date" class="form-control" id="endDate" v-model="newSeason.end_date" required>
          </div>
          <button type="submit" class="btn btn-primary">Přidat ročník</button>
        </form>
      </div>

      <!-- Matches management (rozpis, import) -->
      <div v-if="activeTab === 'matches'" class="tab-content">
        <div class="row">
          <div class="col-md-6">
            <h3>Přidat nový zápas</h3>
            <div v-if="successMessage" class="alert alert-success alert-dismissible fade show" role="alert">
              {{ successMessage }}
              <button type="button" class="btn-close" @click="successMessage = ''"></button>
            </div>
            <form @submit.prevent="addMatch" class="mb-4">
              <div class="mb-3">
                <label for="season" class="form-label">Ročník</label>
                <select class="form-select" id="season" v-model="newMatch.season_id" required>
                  <option v-for="season in seasons" :key="season.id" :value="season.id">
                    {{ season.name }}
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label for="homeTeam" class="form-label">Domácí tým</label>
                <select class="form-select" id="homeTeam" v-model="newMatch.home_team_id" required>
                  <option v-for="team in teams" :key="team.id" :value="team.id">
                    {{ team.name }}
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label for="awayTeam" class="form-label">Hostující tým</label>
                <select class="form-select" id="awayTeam" v-model="newMatch.away_team_id" required>
                  <option v-for="team in teams" :key="team.id" :value="team.id">
                    {{ team.name }}
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label for="matchDate" class="form-label">Datum zápasu</label>
                <input type="datetime-local" class="form-control" id="matchDate" v-model="newMatch.match_date" required>
              </div>
              <div class="mb-3">
                <label for="venue" class="form-label">Místo konání</label>
                <input type="text" class="form-control" id="venue" v-model="newMatch.venue">
              </div>
              <div class="mb-3">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" id="isPlayOff" v-model="newMatch.isPlayOff">
                  <label class="form-check-label" for="isPlayOff">
                    Playoff zápas
                  </label>
                </div>
              </div>
              <button type="submit" class="btn btn-primary">Přidat zápas</button>
            </form>
          </div>
          <div class="col-md-6">
            <h4>Hromadný import zápasů</h4>
            <div class="mb-3">
              <label for="bulkSeason" class="form-label">Ročník</label>
              <select class="form-select" id="bulkSeason" v-model="bulkMatchImport.season_id" required>
                <option v-for="season in seasons" :key="season.id" :value="season.id">
                  {{ season.name }}
                </option>
              </select>
            </div>
            <div class="mb-3">
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="bulkIsPlayOff" v-model="bulkMatchImport.isPlayOff">
                <label class="form-check-label" for="bulkIsPlayOff">
                  Playoff zápasy
                </label>
              </div>
            </div>
            <div class="mb-3">
              <label for="csvMatchesFile" class="form-label">CSV soubor</label>
              <input type="file" class="form-control" id="csvMatchesFile" @change="handleMatchesFileUpload" accept=".csv">
              <small class="form-text text-muted">
                CSV soubor musí obsahovat sloupce: <b>home_team, away_team, match_date, venue</b>
              </small>
            </div>
            <button
              @click="importMatches"
              class="btn btn-primary mb-4"
              :disabled="!bulkMatchImport.file || !bulkMatchImport.season_id"
              :title="!bulkMatchImport.season_id ? 'Nejdříve zvolte ročník' : ''"
              data-bs-toggle="tooltip"
            >
              Importovat zápasy
            </button>
            <button @click="downloadSampleMatchesCsv" class="btn btn-secondary mb-4 ms-2">
              Stáhnout ukázkové CSV
            </button>

            <!-- Ukázková tabulka -->
            <table class="table table-bordered table-sm" style="max-width:600px;">
              <thead>
                <tr>
                  <th>home_team</th>
                  <th>away_team</th>
                  <th>match_date</th>
                  <th>venue</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Blackbirds</td>
                  <td>Blackhawks</td>
                  <td>2024-10-01 18:00</td>
                  <td>Zimni stadion</td>
                </tr>
                <tr>
                  <td>Tigers</td>
                  <td>Wolves</td>
                  <td>2024-10-02 19:30</td>
                  <td>Arena Brno</td>
                </tr>
                <tr>
                  <td>Eagles</td>
                  <td>Panthers</td>
                  <td>2024-10-03 17:45</td>
                  <td>Hala Ostrava</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Results management (výsledky zápasů) -->
      <div v-if="activeTab === 'results'" class="tab-content">
        <h3>Výsledky zápasů</h3>
        <div class="mb-3">
          <label for="resultsSeasonSelect" class="form-label">Ročník</label>
          <select
            id="resultsSeasonSelect"
            class="form-select"
            v-model="selectedResultsSeasonId"
            @change="loadMatches(selectedResultsSeasonId)"
          >
            <option value="">Všechny ročníky</option>
            <option v-for="season in seasons" :key="season.id" :value="season.id">
              {{ season.name }}
            </option>
          </select>
        </div>
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th>Datum</th>
                <th>Domácí</th>
                <th>Hosté</th>
                <th>Místo konání</th>
                <th>Playoff</th>
                <th>Výsledek</th>
                <th>Akce</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="match in matches" :key="match.id">
                <template v-if="editMatchId !== match.id">
                  <td>{{ formatDate(match.match_date) }}</td>
                  <td>{{ getTeamName(match.home_team_id) }}</td>
                  <td>{{ getTeamName(match.away_team_id) }}</td>
                  <td>{{ match.venue }}</td>
                  <td>
                    <span v-if="match.isplayoff" class="badge bg-danger">Playoff</span>
                    <span v-else class="badge bg-secondary">Základní část</span>
                  </td>
                  <td>
                    <template v-if="match.status === 'played'">
                      {{ match.home_score }}:{{ match.away_score }}
                    </template>
                    <template v-else>
                      <button class="btn btn-sm btn-primary" @click="showAddResultForm(match)">
                        Zadat výsledek
                      </button>
                    </template>
                    <button class="btn btn-sm btn-secondary ms-2" @click="showUploadRecordModal(match)">
                      Vložit zápis
                    </button>
                  </td>
                  <td>
                    <button class="btn btn-sm btn-warning me-2" @click="showAddResultForm(match)">Upravit vysledek</button>
                    <button class="btn btn-sm btn-warning me-2" @click="showEditEventForm(match)">Upravit udalost</button>
                    <button v-if="match.status !== 'played'" class="btn btn-sm btn-danger" @click="deleteMatch(match.id)">Smazat zápas</button>
                  </td>
                </template>
                <template v-else>
                  <td><input type="datetime-local" class="form-control" v-model="editMatch.match_date" disabled /></td>
                  <td>
                    <select class="form-select" v-model="editMatch.home_team_id" disabled>
                      <option v-for="team in teams" :key="team.id" :value="team.id">{{ team.name }}</option>
                    </select>
                  </td>
                  <td>
                    <select class="form-select" v-model="editMatch.away_team_id" disabled>
                      <option v-for="team in teams" :key="team.id" :value="team.id">{{ team.name }}</option>
                    </select>
                  </td>
                  <td><input type="text" class="form-control" v-model="editMatch.venue" disabled /></td>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" id="editIsPlayOff" v-model="editMatch.isplayoff">
                      <label class="form-check-label" for="editIsPlayOff">Playoff</label>
                    </div>
                  </td>
                  <td>
                    <input type="number" class="form-control d-inline-block" style="width:70px;" v-model="editMatch.home_score" />
                    :
                    <input type="number" class="form-control d-inline-block" style="width:70px;" v-model="editMatch.away_score" />
                  </td>
                  <td>
                    <button class="btn btn-sm btn-success me-2" @click="saveEditMatch(match.id)">Uložit</button>
                    <button class="btn btn-sm btn-secondary" @click="cancelEditMatch">Zrušit</button>
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Add Result Modal -->
        <div class="modal fade" id="addResultModal" tabindex="-1">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Zadat výsledek zápasu</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
              </div>
              <div class="modal-body">
                <form @submit.prevent="addResult">
                  <div class="row mb-4">
                    <div class="col-md-6">
                      <h6>{{ getTeamName(selectedMatch?.home_team_id) }}</h6>
                      <div class="mb-3">
                        <label class="form-label">Skóre</label>
                        <input type="number" class="form-control" v-model="newResult.home_score" required min="0">
                      </div>
                    </div>
                    <div class="col-md-6">
                      <h6>{{ getTeamName(selectedMatch?.away_team_id) }}</h6>
                      <div class="mb-3">
                        <label class="form-label">Skóre</label>
                        <input type="number" class="form-control" v-model="newResult.away_score" required min="0">
                      </div>
                    </div>
                  </div>

                  <!-- GÓLY -->
                  <h6 class="mt-4">Góly</h6>
                  <button type="button" class="btn btn-secondary mb-3" @click="showGoalDialog">Přidat gól</button>
                  <table class="table table-sm" v-if="newResult.goals.length">
                    <thead>
                      <tr>
                        <th>Střelec</th>
                        <th>Asistence</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(goal, index) in newResult.goals" :key="index">
                        <td>{{ getPlayerName(goal.player_id) }}</td>
                        <td>{{ goal.assist ? getPlayerName(goal.assist) : '-- bez asistence --' }}</td>
                        <td><button type="button" class="btn btn-danger btn-sm" @click="removeGoal(index)">Odstranit</button></td>
                      </tr>
                    </tbody>
                  </table>

                  <!-- BRANKÁŘI -->
                  <h6 class="mt-4">Statistiky brankářů</h6>
                  <button type="button" class="btn btn-secondary mb-3" @click="showGoalieDialog">Přidat brankáře</button>
                  <table class="table table-sm" v-if="newResult.goalieStats.length">
                    <thead>
                      <tr>
                        <th>Brankář</th>
                        <th>Zákroky</th>
                        <th>Zachráněné</th>
                        <th>Obdržené</th>
                        <th>Minuty</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(stats, index) in newResult.goalieStats" :key="index">
                        <td>{{ getPlayerName(stats.player_id) }}</td>
                        <td>{{ stats.shots_against }}</td>
                        <td>{{ stats.saves }}</td>
                        <td>{{ stats.goals_against }}</td>
                        <td>{{ stats.minutes_played }}</td>
                        <td><button type="button" class="btn btn-danger btn-sm" @click="removeGoalieStats(index)">Odstranit</button></td>
                      </tr>
                    </tbody>
                  </table>

                  <button type="submit" class="btn btn-primary mt-3">Uložit výsledek</button>
                </form>
              </div>
            </div>
          </div>
        </div>

        <!-- GOAL DIALOG -->
        <div class="modal fade" id="goalDialog" tabindex="-1">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Přidat gól</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
              </div>
              <div class="modal-body">
                <form @submit.prevent="addGoalFromDialog">
                  <div class="mb-3">
                    <label class="form-label">Střelec</label>
                    <label class="form-label small text-secondary d-block">Hledat podle příjmení</label>
                    <input
                      v-model="goalDialogScorerSearch"
                      type="text"
                      class="form-control form-control-sm mb-2"
                      placeholder="Začněte psát příjmení…"
                      autocomplete="off"
                    />
                    <select class="form-select" v-model="goalDialog.player_id" required>
                      <option v-for="player in filteredPlayersForGoalScorer" :key="player.id" :value="player.id">
                        {{ player.first_name }} {{ player.last_name }} ({{ getTeamName(player.team_id) }})
                      </option>
                    </select>
                  </div>
                  <div class="mb-3">
                    <label class="form-label">Asistence</label>
                    <label class="form-label small text-secondary d-block">Hledat podle příjmení</label>
                    <input
                      v-model="goalDialogAssistSearch"
                      type="text"
                      class="form-control form-control-sm mb-2"
                      placeholder="Začněte psát příjmení…"
                      autocomplete="on"
                    />
                    <select class="form-select" v-model="goalDialog.assist">
                      <option value="">-- bez asistence --</option>
                      <option v-for="player in filteredPlayersForGoalAssist" :key="player.id" :value="player.id">
                        {{ player.first_name }} {{ player.last_name }} ({{ getTeamName(player.team_id) }})
                      </option>
                    </select>
                  </div>
                  <button type="submit" class="btn btn-primary">Přidat gól</button>
                </form>
              </div>
            </div>
          </div>
        </div>

        <!-- GOALIE DIALOG -->
        <div class="modal fade" id="goalieDialog" tabindex="-1">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Přidat brankáře</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
              </div>
              <div class="modal-body">
                <form @submit.prevent="addGoalieFromDialog">
                  <div class="mb-3">
                    <label class="form-label">Brankář</label>
                    <select class="form-select" v-model="goalieDialog.player_id" required>
                      <option v-for="player in availableGoalies" :key="player.id" :value="player.id">
                        {{ player.first_name }} {{ player.last_name }} ({{ getTeamName(player.team_id) }})
                      </option>
                    </select>
                  </div>
                  <div class="mb-3">
                    <label class="form-label">Zákroky</label>
                    <input type="number" class="form-control" v-model="goalieDialog.shots_against" required min="0">
                  </div>
                  <div class="mb-3">
                    <label class="form-label">Zachráněné</label>
                    <input type="number" class="form-control" v-model="goalieDialog.saves" required min="0">
                  </div>
                  <div class="mb-3">
                    <label class="form-label">Obdržené</label>
                    <input type="number" class="form-control" v-model="goalieDialog.goals_against" required min="0">
                  </div>
                  <div class="mb-3">
                    <label class="form-label">Minuty</label>
                    <input type="number" class="form-control" v-model="goalieDialog.minutes_played" required min="0">
                  </div>
                  <button type="submit" class="btn btn-primary">Přidat brankáře</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sponsors management -->
      <div v-if="activeTab === 'sponsors'" class="tab-content">
        <h3>Přidat nového sponzora</h3>
        <form @submit.prevent="addSponsor" class="mb-4">
          <div class="mb-3">
            <label for="sponsorName" class="form-label">Název sponzora</label>
            <input type="text" class="form-control" id="sponsorName" v-model="newSponsor.name" required>
          </div>
          <div class="mb-3">
            <label for="sponsorLogo" class="form-label">URL loga</label>
            <input type="text" class="form-control" id="sponsorLogo" v-model="newSponsor.logo">
          </div>
          <div class="mb-3">
            <label for="sponsorWebsite" class="form-label">Webové stránky</label>
            <input type="text" class="form-control" id="sponsorWebsite" v-model="newSponsor.website">
          </div>
          <div class="mb-3">
            <label for="sponsorDescription" class="form-label">Popis</label>
            <textarea class="form-control" id="sponsorDescription" v-model="newSponsor.description" rows="3"></textarea>
          </div>
          <button type="submit" class="btn btn-primary">Přidat sponzora</button>
        </form>
        <h3>Seznam sponzorů</h3>
        <table class="table">
          <thead>
            <tr>
              <th>Název</th>
              <th>Logo</th>
              <th>Web</th>
              <th>Popis</th>
              <th>Akce</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="sponsor in sponsors" :key="sponsor.id">
              <td v-if="editSponsorId !== sponsor.id">{{ sponsor.name }}</td>
              <td v-else><img v-if="sponsor.logo" :src="getLogoUrl(sponsor.logo)" alt="logo" style="height:32px;" /></td>
              <td v-if="editSponsorId !== sponsor.id"><a v-if="sponsor.website" :href="sponsor.website" target="_blank">{{ sponsor.website }}</a></td>
              <td v-if="editSponsorId !== sponsor.id">{{ sponsor.description }}</td>
              <td>
                <button v-if="editSponsorId !== sponsor.id" class="btn btn-sm btn-warning me-2" @click="startEditSponsor(sponsor)">Upravit</button>
                <button v-else class="btn btn-sm btn-success me-2" @click="saveEditSponsor(sponsor.id)">Uložit</button>
                <button v-if="editSponsorId === sponsor.id" class="btn btn-sm btn-secondary me-2" @click="cancelEditSponsor">Zrušit</button>
                <button class="btn btn-sm btn-danger" @click="deleteSponsor(sponsor.id)">Smazat</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- DK management -->
      <div v-if="activeTab === 'dk'" class="tab-content">
        <h3>Disciplinární komise</h3>
        <ul class="nav nav-tabs mb-4">
          <li class="nav-item">
            <a class="nav-link" :class="{ active: dkTab === 'members' }" @click="dkTab = 'members'" href="#">
              Členové DK
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" :class="{ active: dkTab === 'messages' }" @click="dkTab = 'messages'" href="#">
              Zprávy DK
            </a>
          </li>
        </ul>
        <!-- Členové DK -->
        <div v-if="dkTab === 'members'" class="table-responsive">
          <div class="mb-4">
            <h4>Přidat člena DK</h4>
            <form @submit.prevent="addDKMember" class="row g-3">
              <div class="col-md-6">
                <select v-model="newDKMember.team_id" class="form-select" required>
                  <option value="">Vyberte tým</option>
                  <option v-for="team in teams" :key="team.id" :value="team.id">
                    {{ team.name }}
                  </option>
                </select>
              </div>
              <div class="col-md-6">
                <select v-model="newDKMember.player_id" class="form-select" required>
                  <option value="">Vyberte hráče</option>
                  <option v-for="player in dkAvailablePlayers" :key="player.id" :value="player.id">
                    {{ player.first_name }} {{ player.last_name }}
                  </option>
                </select>
              </div>
              <div class="col-12">
                <button type="submit" class="btn btn-primary">Přidat člena</button>
              </div>
            </form>
          </div>
          <table class="table">
            <thead>
              <tr>
                <th>Tým</th>
                <th>Člen DK</th>
                <th>Od</th>
                <th>Akce</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="member in dkMembers" :key="member.id">
                <td>
                  <div class="d-flex align-items-center">
                    <img v-if="member.team_logo" :src="getLogoUrl(member.team_logo)" :alt="member.team_name + ' logo'" class="team-logo me-2" />
                    <span v-else class="team-logo-placeholder me-2"></span>
                    {{ member.team_name }}
                  </div>
                </td>
                <td>{{ member.first_name }} {{ member.last_name }}</td>
                <td>{{ formatDate(member.created_at) }}</td>
                <td>
                  <button class="btn btn-danger btn-sm" @click="removeDKMember(member.id)">Odstranit</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Zprávy DK -->
        <div v-if="dkTab === 'messages'">
          <div class="mb-4">
            <h4>Nová zpráva DK</h4>
            <form @submit.prevent="addDKMessage" class="mb-4">
              <div class="mb-3">
                <label class="form-label">Nadpis</label>
                <input type="text" class="form-control" v-model="newDKMessage.title" required>
              </div>
              <div class="mb-3">
                <label class="form-label">Zpráva</label>
                <textarea class="form-control" v-model="newDKMessage.message" rows="4" required></textarea>
              </div>
              <button type="submit" class="btn btn-primary">Publikovat</button>
            </form>
          </div>
          <div class="dk-messages">
            <div v-for="message in dkMessages" :key="message.id" class="dk-message card mb-3">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start">
                  <h5 class="card-title">{{ message.title }}</h5>
                  <small class="text-dimmed">{{ formatDate(message.created_at) }}</small>
                </div>
                <p class="card-text">{{ message.message }}</p>
                <div class="mt-3">
                  <button class="btn btn-danger btn-sm me-2" @click="deleteDKMessage(message.id)">Smazat</button>
                  <button class="btn btn-secondary btn-sm" @click="editDKMessage(message)">Upravit</button>
                </div>
              </div>
            </div>
          </div>
          <!-- Edit Message Modal -->
          <div class="modal fade" id="editMessageModal" tabindex="-1">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Upravit zprávu</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                  <form @submit.prevent="updateDKMessage">
                    <div class="mb-3">
                      <label class="form-label">Nadpis</label>
                      <input type="text" class="form-control" v-model="editingDKMessage.title" required>
                    </div>
                    <div class="mb-3">
                      <label class="form-label">Zpráva</label>
                      <textarea class="form-control" v-model="editingDKMessage.message" rows="4" required></textarea>
                    </div>
                    <div class="mb-3">
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" v-model="editingDKMessage.is_published">
                        <label class="form-check-label">Publikováno</label>
                      </div>
                    </div>
                    <button type="submit" class="btn btn-primary">Uložit změny</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- League Management Tab -->
      <div v-if="activeTab === 'league-management'" class="tab-content">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h3>Správa vedení ligy</h3>
          <button class="btn btn-primary" @click="showLeagueManagementDialog()">Přidat člena vedení</button>
        </div>

        <!-- Add League Management Member Form (for Člen vedení) -->
        <div class="mb-4">
          <h4>Přidat člena vedení (z týmu)</h4>
          <form @submit.prevent="addLeagueManagementFromForm" class="row g-3">
            <div class="col-md-6">
              <select v-model="newLeagueManagement.team_id" class="form-select" required>
                <option value="">Vyberte tým</option>
                <option v-for="team in teams" :key="team.id" :value="team.id">
                  {{ team.name }}
                </option>
              </select>
            </div>
            <div class="col-md-6">
              <select v-model="newLeagueManagement.player_id" class="form-select" required>
                <option value="">Vyberte hráče</option>
                <option v-for="player in leagueManagementAvailablePlayers" :key="player.id" :value="player.id">
                  {{ player.first_name }} {{ player.last_name }}
                </option>
              </select>
            </div>
            <div class="col-12">
              <button type="submit" class="btn btn-primary">Přidat člena vedení</button>
            </div>
          </form>
        </div>

        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th>Jméno</th>
                <th>Role</th>
                <th>Akce</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="member in leagueManagement" :key="member.id">
                <td>{{ member.first_name }} {{ member.last_name }}</td>
                <td>
                  <span v-if="member.role === 'president'" class="badge bg-primary">Prezident</span>
                  <span v-else-if="member.role === 'vice_president'" class="badge bg-info">Viceprezident</span>
                  <span v-else-if="member.role === 'founder'" class="badge bg-success">Zakladatel</span>
                  <span v-else class="badge bg-secondary">Člen vedení</span>
                </td>
                <td>
                  <button class="btn btn-sm btn-warning me-2" @click="showLeagueManagementDialog(member)">Upravit</button>
                  <button class="btn btn-sm btn-danger" @click="deleteLeagueManagement(member.id)">Smazat</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- League Management Dialog -->
      <div class="modal fade" id="leagueManagementModal" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ editedLeagueManagement.id ? 'Upravit člena vedení' : 'Přidat člena vedení' }}</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="saveLeagueManagement">
                <div class="mb-3">
                  <label class="form-label">Jméno</label>
                  <input v-model="editedLeagueManagement.first_name" type="text" class="form-control" required>
                </div>
                <div class="mb-3">
                  <label class="form-label">Příjmení</label>
                  <input v-model="editedLeagueManagement.last_name" type="text" class="form-control" required>
                </div>
                <div class="mb-3">
                  <label class="form-label">Role</label>
                  <select v-model="editedLeagueManagement.role" class="form-select" required>
                    <option value="president">Prezident</option>
                    <option value="vice_president">Viceprezident</option>
                    <option value="founder">Zakladatel</option>
                    <option value="member">Člen vedení</option>
                  </select>
                </div>
                <div class="text-end">
                  <button type="button" class="btn btn-secondary me-2" data-bs-dismiss="modal">Zrušit</button>
                  <button type="submit" class="btn btn-primary">Uložit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <!-- Team Managers Tab -->
      <div v-if="activeTab === 'team-managers'" class="tab-content">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h3>Správa vedoucích týmů</h3>
          <!-- <button class="btn btn-primary" @click="showTeamManagerDialog()">Přidat vedoucího</button> -->
        </div>

        <!-- Add Team Manager Form -->
        <div class="mb-4">
          <h4>Přidat vedoucího týmu</h4>
          <form @submit.prevent="addTeamManagerFromForm" class="row g-3">
            <div class="col-md-6">
              <select v-model="newTeamManager.team_id" class="form-select" required>
                <option value="">Vyberte tým</option>
                <option v-for="team in teams" :key="team.id" :value="team.id">
                  {{ team.name }}
                </option>
              </select>
            </div>
            <div class="col-md-6">
              <select v-model="newTeamManager.player_id" class="form-select" required>
                <option value="">Vyberte hráče</option>
                <option v-for="player in teamManagerAvailablePlayers" :key="player.id" :value="player.id">
                  {{ player.first_name }} {{ player.last_name }}
                </option>
              </select>
            </div>
            
            <div class="col-12">
              <button type="submit" class="btn btn-primary">Přidat vedoucího</button>
            </div>
            
          </form>
        </div>

        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th>Tým</th>
                <th>Jméno</th>
                <th>Akce</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="manager in teamManagers" :key="manager.id">
                <td>
                  <div class="d-flex align-items-center">
                    <img v-if="manager.team_logo" :src="getLogoUrl(manager.team_logo)" :alt="manager.team_name + ' logo'" class="team-logo me-2" />
                    <span v-else class="team-logo-placeholder me-2"></span>
                    {{ manager.team_name }}
                  </div>
                </td>
                <td>{{ manager.first_name }} {{ manager.last_name }}</td>
                <td>
                  <button class="btn btn-sm btn-warning me-2" @click="showTeamManagerDialog(manager)">Upravit</button>
                  <button class="btn btn-sm btn-danger" @click="deleteTeamManager(manager.id)">Smazat</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Team Manager Dialog -->
      <div class="modal fade" id="teamManagerModal" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ editedTeamManager.id ? 'Upravit vedoucího' : 'Přidat vedoucího' }}</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="saveTeamManager">
                <div class="mb-3">
                  <label class="form-label">Tým</label>
                  <select v-model="editedTeamManager.team_id" class="form-select" required>
                    <option v-for="team in teams" :key="team.id" :value="team.id">{{ team.name }}</option>
                  </select>
                </div>
                <div class="mb-3">
                  <label class="form-label">Jméno</label>
                  <input v-model="editedTeamManager.first_name" type="text" class="form-control" required>
                </div>
                <div class="mb-3">
                  <label class="form-label">Příjmení</label>
                  <input v-model="editedTeamManager.last_name" type="text" class="form-control" required>
                </div>
                <div class="text-end">
                  <button type="button" class="btn btn-secondary me-2" data-bs-dismiss="modal">Zrušit</button>
                  <button type="submit" class="btn btn-primary">Uložit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <!-- Playoff Bracket Tab -->
      <div v-if="activeTab === 'playoff-bracket'" class="tab-content">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h3>Správa Playoff pavouka</h3>
        </div>

        <!-- Season selector -->
        <div class="mb-4">
          <label for="playoffSeason" class="form-label">Ročník</label>
          <select id="playoffSeason" class="form-select" v-model="playoffBracketSeason" @change="loadPlayoffBracket">
            <option value="">Vyberte ročník</option>
            <option v-for="season in seasons" :key="season.id" :value="season.id">
              {{ season.name }}
            </option>
          </select>
        </div>

        <!-- Add new match to bracket -->
        <div class="mb-4">
          <h4>Přidat zápas do pavouka</h4>
          <form @submit.prevent="addPlayoffBracketMatch" class="row g-3">
            <div class="col-md-3">
              <label class="form-label">Kolo</label>
              <input type="number" class="form-control" v-model="newPlayoffMatch.round" required min="1" placeholder="1, 2, 3...">
            </div>
            <div class="col-md-3">
              <label class="form-label">Číslo zápasu v kole</label>
              <input type="number" class="form-control" v-model="newPlayoffMatch.match_number" required min="1" placeholder="1, 2, 3...">
            </div>
            <div class="col-md-3">
              <label class="form-label">Tým 1</label>
              <select class="form-select" v-model="newPlayoffMatch.team1_id" required>
                <option value="">Vyberte tým</option>
                <option v-for="team in teams" :key="team.id" :value="team.id">
                  {{ team.name }}
                </option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="form-label">Tým 2</label>
              <select class="form-select" v-model="newPlayoffMatch.team2_id" required>
                <option value="">Vyberte tým</option>
                <option v-for="team in teams" :key="team.id" :value="team.id">
                  {{ team.name }}
                </option>
              </select>
            </div>
            <div class="col-12">
              <button type="submit" class="btn btn-primary">Přidat zápas</button>
            </div>
          </form>
        </div>

        <!-- Display bracket by rounds -->
        <div v-if="playoffBracket.length > 0">
          <div v-for="round in getUniqueRounds()" :key="round" class="mb-5">
            <h4 class="mb-3">Kolo {{ round }}</h4>
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>Číslo zápasu</th>
                    <th>Tým 1</th>
                    <th>Tým 2</th>
                    <th>Vítěz</th>
                    <th>Akce</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="match in getMatchesByRound(round)" :key="match.id">
                    <td>{{ match.match_number }}</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <img v-if="match.team1_logo" :src="getLogoUrl(match.team1_logo)" class="team-logo me-2" />
                        <span v-else class="team-logo-placeholder me-2"></span>
                        {{ match.team1_name || 'TBD' }}
                      </div>
                    </td>
                    <td>
                      <div class="d-flex align-items-center">
                        <img v-if="match.team2_logo" :src="getLogoUrl(match.team2_logo)" class="team-logo me-2" />
                        <span v-else class="team-logo-placeholder me-2"></span>
                        {{ match.team2_name || 'TBD' }}
                      </div>
                    </td>
                    <td>
                      <div v-if="match.winner_name" class="d-flex align-items-center">
                        <img v-if="match.winner_logo" :src="getLogoUrl(match.winner_logo)" class="team-logo me-2" />
                        <span v-else class="team-logo-placeholder me-2"></span>
                        {{ match.winner_name }}
                      </div>
                      <div v-else>
                        <select class="form-select form-select-sm" v-model="match.selectedWinner" @change="setPlayoffWinner(match)">
                          <option value="">Vyberte vítěze</option>
                          <option v-if="match.team1_id" :value="match.team1_id">{{ match.team1_name }}</option>
                          <option v-if="match.team2_id" :value="match.team2_id">{{ match.team2_name }}</option>
                        </select>
                      </div>
                    </td>
                    <td>
                      <button class="btn btn-sm btn-danger" @click="deletePlayoffMatch(match.id)">Smazat</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div v-else-if="playoffBracketSeason" class="alert alert-info">
          Pro tento ročník zatím nejsou žádné zápasy v playoff pavouku.
        </div>
      </div>

      <!-- Aktuality -->
      <div v-if="activeTab === 'news'" class="tab-content">
        <h3 class="mb-3">Správa aktualit (úvodní stránka)</h3>
        <form @submit.prevent="addNewsArticle" class="mb-4">
          <div class="mb-3">
            <label class="form-label">Nadpis</label>
            <input v-model="newNewsArticle.title" type="text" class="form-control" required>
          </div>
          <div class="mb-3">
            <label class="form-label">Perex (náhled na kartě)</label>
            <textarea v-model="newNewsArticle.excerpt" class="form-control" rows="2"></textarea>
          </div>
          <div class="mb-3">
            <label class="form-label">Obsah (HTML)</label>
            <textarea v-model="newNewsArticle.content" class="form-control" rows="6" required placeholder="např. &lt;p&gt;Odstavce…&lt;/p&gt;"></textarea>
          </div>
          <div class="mb-3">
            <label class="form-label">Autor</label>
            <input v-model="newNewsArticle.author" type="text" class="form-control">
          </div>
          <div class="mb-3">
            <label class="form-label">Datum a čas publikace</label>
            <input v-model="newNewsArticle.published_at" type="datetime-local" class="form-control">
            <small class="form-text text-dimmed">Prázdné = okamžitě při uložení</small>
          </div>
          <div class="mb-3">
            <label class="form-label">URL titulního obrázku</label>
            <input v-model="newNewsArticle.cover_image" type="text" class="form-control" placeholder="Volitelná externí URL (https://…); nahraný soubor jde do databáze">
          </div>
          <div class="mb-3">
            <label class="form-label">Nebo nahrát obrázek</label>
            <input ref="newsNewCoverInput" type="file" accept="image/jpeg,image/png,image/gif" class="form-control" @change="onNewsCoverFileChange($event, 'new')">
            <small class="form-text text-dimmed">Vybraný obrázek se uloží do PostgreSQL (binárně) při kliknutí na „Přidat článek“.</small>
          </div>
          <div v-if="newNewsArticle.cover_image || newsNewCoverPreviewUrl" class="mb-3">
            <img :src="newsNewCoverPreviewUrl || getLogoUrl(newNewsArticle.cover_image)" alt="Náhled" style="max-height: 120px; border-radius: 0.5rem;">
          </div>
          <div class="mb-3 form-check">
            <input id="newNewsPublished" v-model="newNewsArticle.is_published" type="checkbox" class="form-check-input">
            <label class="form-check-label" for="newNewsPublished">Publikováno</label>
          </div>
          <button type="submit" class="btn btn-primary">Přidat článek</button>
        </form>

        <h4 class="mb-3">Seznam článků</h4>
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th>Datum publikace</th>
                <th>Nadpis</th>
                <th>Stav</th>
                <th>Akce</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="article in newsArticles" :key="article.id">
                <td>{{ formatNewsArticleDate(article.published_at) }}</td>
                <td>{{ article.title }}</td>
                <td>{{ article.is_published ? 'Publikováno' : 'Koncept' }}</td>
                <td>
                  <button type="button" class="btn btn-sm btn-secondary me-2" @click="openEditNewsModal(article)">Upravit</button>
                  <button type="button" class="btn btn-sm btn-danger" @click="deleteNewsArticle(article.id)">Smazat</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p v-if="newsArticles.length === 0" class="text-dimmed">Zatím žádné články.</p>
      </div>
    </div>
  </div>

  <!-- Logo Selection Modal -->
  <div class="modal fade" id="logoSelectionModal" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Vyberte logo týmu</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          <div class="row row-cols-2 row-cols-md-4 g-3">
            <div v-for="logo in availableLogos" :key="logo" class="col">
              <div class="logo-item" :class="{ 'selected': selectedLogo === logo }" @click="selectLogo(logo)">
                <img :src="getLogoUrl(`uploads/logos/${logo}`)" :alt="logo" class="img-fluid">
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Zrušit</button>
          <button type="button" class="btn btn-primary" @click="confirmLogoSelection">Potvrdit výběr</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Add Transfer Modal -->
  <div class="modal fade" id="transferModal" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Přestup hráče</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="transferPlayer">
            <div class="mb-3">
              <label class="form-label">Nový tým</label>
              <select class="form-select" v-model="transferData.new_team_id" required>
                <option v-for="team in teams" :key="team.id" :value="team.id">
                  {{ team.name }}
                </option>
              </select>
            </div>
            <div class="mb-3">
              <label class="form-label">Nové číslo dresu</label>
              <input type="number" class="form-control" v-model="transferData.new_jersey_number" required min="1" max="99">
            </div>
            <button type="submit" class="btn btn-primary">Potvrdit přestup</button>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Upload Match Record Modal -->
  <div class="modal fade" id="uploadRecordModal" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Vložit zápis z utkání</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="uploadMatchRecord">
            <div class="mb-3">
              <input type="file" class="form-control" ref="recordInput" accept="image/*" required />
            </div>
            <button type="submit" class="btn btn-primary">Nahrát zápis</button>
            <span v-if="uploadingRecord" class="ms-2">Nahrávám...</span>
            <span v-if="uploadRecordError" class="text-danger ms-2">{{ uploadRecordError }}</span>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Edit Event Modal -->
  <div class="modal fade" id="editEventModal" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Upravit událost zápasu</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="saveEventChanges">
            <div class="mb-3">
              <label class="form-label">Datum a čas</label>
              <input type="datetime-local" class="form-control" v-model="editEventData.match_date" required>
            </div>
            <div class="mb-3">
              <label class="form-label">Místo konání</label>
              <input type="text" class="form-control" v-model="editEventData.venue" required>
            </div>
            <div class="d-flex justify-content-end gap-2">
              <button type="button" class="btn btn-secondary" @click="cancelEditEvent">Zrušit</button>
              <button type="submit" class="btn btn-primary">Uložit změny</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Edit News Article Modal -->
  <div class="modal fade" id="editNewsModal" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Upravit článek</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="updateNewsArticle">
            <div class="mb-3">
              <label class="form-label">Nadpis</label>
              <input v-model="editingNewsArticle.title" type="text" class="form-control" required>
            </div>
            <div class="mb-3">
              <label class="form-label">Perex</label>
              <textarea v-model="editingNewsArticle.excerpt" class="form-control" rows="2"></textarea>
            </div>
            <div class="mb-3">
              <label class="form-label">Obsah (HTML)</label>
              <textarea v-model="editingNewsArticle.content" class="form-control" rows="8" required></textarea>
            </div>
            <div class="mb-3">
              <label class="form-label">Autor</label>
              <input v-model="editingNewsArticle.author" type="text" class="form-control">
            </div>
            <div class="mb-3">
              <label class="form-label">Datum a čas publikace</label>
              <input v-model="editingNewsArticle.published_at" type="datetime-local" class="form-control">
              <small class="form-text text-dimmed">Prázdné = ponechat stávající</small>
            </div>
            <div class="mb-3">
              <label class="form-label">URL titulního obrázku</label>
              <input v-model="editingNewsArticle.cover_image" type="text" class="form-control">
            </div>
            <div class="mb-3">
              <label class="form-label">Nebo nahrát obrázek</label>
              <input ref="newsEditCoverInput" type="file" accept="image/jpeg,image/png,image/gif" class="form-control" @change="onNewsCoverFileChange($event, 'edit')">
              <small class="form-text text-dimmed">Nový soubor se uloží při „Uložit změny“ spolu se zápisem cesty k obrázku.</small>
            </div>
            <div v-if="!removeNewsCover && (editingNewsArticle.cover_image || editingNewsHadBlob || editingNewsCoverPreviewUrl)" class="mb-3">
              <img
                :src="editingNewsCoverPreviewUrl || (editingNewsArticle.cover_image ? getLogoUrl(editingNewsArticle.cover_image) : getLogoUrl(`/api/news/${editingNewsArticle.id}/cover`))"
                alt="Náhled"
                style="max-height: 120px; border-radius: 0.5rem;"
              >
            </div>
            <div class="mb-3 form-check">
              <input id="removeNewsCover" v-model="removeNewsCover" type="checkbox" class="form-check-input">
              <label class="form-check-label" for="removeNewsCover">Odstranit titulní obrázek</label>
            </div>
            <div class="mb-3 form-check">
              <input id="editNewsPublished" v-model="editingNewsArticle.is_published" type="checkbox" class="form-check-input">
              <label class="form-check-label" for="editNewsPublished">Publikováno</label>
            </div>
            <button type="submit" class="btn btn-primary">Uložit změny</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { Modal } from 'bootstrap';

export default {
  name: 'AdminPanel',
  data() {
    return {
      isLoggedIn: false,
      loginForm: {
        username: '',
        password: ''
      },
      successMessage: '',
      activeTab: 'teams',
      teams: [],
      seasons: [],
      matches: [],
      selectedResultsSeasonId: '',
      sponsors: [],
      players: [],
      newTeam: {
        name: '',
        logo: null,
        logoPreview: null
      },
      editTeamId: null,
      editTeam: {
        name: '',
        logo: null,
        logoPreview: null
      },
      newSeason: {
        name: '',
        start_date: '',
        end_date: ''
      },
      newMatch: {
        season_id: '',
        home_team_id: '',
        away_team_id: '',
        match_date: '',
        venue: '',
        isPlayOff: false
      },
      editMatchId: null,
      editMatch: { season_id: '', home_team_id: '', away_team_id: '', match_date: '', venue: '', home_score: '', away_score: '', status: '', isPlayOff: false },
      newSponsor: {
        name: '',
        logo: '',
        website: '',
        description: ''
      },
      editSponsorId: null,
      editSponsor: { name: '', logo: '', website: '', description: '' },
      newPlayer: {
        team_id: '',
        first_name: '',
        last_name: '',
        jersey_number: '',
        position: 'Útočník',
        is_registered: true
      },
      editPlayerId: null,
      editPlayer: {
        team_id: '',
        first_name: '',
        last_name: '',
        jersey_number: '',
        position: '',
        is_registered: true,
        isFreeAgent: false,
        note: ''
      },
      bulkImport: {
        team_id: '',
        file: null
      },
      selectedTeamId: null,
      selectedMatch: null,
      availablePlayers: [],
      availableGoalies: [],
      newResult: {
        home_score: '',
        away_score: '',
        goals: [],
        goalieStats: []
      },
      goalDialog: {
        player_id: '',
        assist: ''
      },
      goalDialogScorerSearch: '',
      goalDialogAssistSearch: '',
      goalieDialog: {
        player_id: '',
        shots_against: '',
        saves: '',
        goals_against: '',
        minutes_played: ''
      },
      bulkMatchImport: {
        season_id: '',
        file: null,
        isPlayOff: false
      },
      availableLogos: [],
      selectedLogo: null,
      logoSelectionMode: null, // 'new' or 'edit'
      logoSelectionModal: null,
      editTeamLogoInputs: {}, // Add this new property to store refs by team ID
      transferData: {
        new_team_id: '',
        new_jersey_number: ''
      },
      dkTab: 'members',
      dkMembers: [],
      dkAvailablePlayers: [],
      newDKMember: {
        team_id: '',
        player_id: ''
      },
      newDKMessage: {
        title: '',
        message: '',
        is_published: true
      },
      editingDKMessage: {
        title: '',
        message: '',
        is_published: true
      },
      dkMessages: [],
      uploadingRecord: false,
      uploadRecordError: '',
      recordUploadMatch: null,
      // Add new properties for event editing
      editEventMatch: null,
      editEventData: {
        match_date: '',
        venue: ''
      },
      leagueManagement: [],
      teamManagers: [],
      editedLeagueManagement: {
        id: null,
        first_name: '',
        last_name: '',
        role: 'member'
      },
      editedTeamManager: {
        id: null,
        team_id: null,
        first_name: '',
        last_name: ''
      },
      leagueManagementModal: null,
      teamManagerModal: null,
      newTeamManager: {
        team_id: '',
        player_id: ''
      },
      teamManagerAvailablePlayers: [],
      newLeagueManagement: {
        team_id: '',
        player_id: ''
      },
      leagueManagementAvailablePlayers: [],
      playoffBracketSeason: '',
      playoffBracket: [],
      newPlayoffMatch: {
        season_id: '',
        round: 1,
        match_number: 1,
        team1_id: '',
        team2_id: ''
      },
      newsArticles: [],
      newNewsArticle: {
        title: '',
        excerpt: '',
        content: '',
        author: '',
        published_at: '',
        is_published: true,
        cover_image: ''
      },
      editingNewsArticle: {
        id: null,
        title: '',
        excerpt: '',
        content: '',
        author: '',
        published_at: '',
        is_published: true,
        cover_image: ''
      },
      newsNewCoverFile: null,
      editingNewsCoverFile: null,
      newsNewCoverPreviewUrl: null,
      editingNewsCoverPreviewUrl: null,
      editingNewsHadBlob: false,
      removeNewsCover: false
    }
  },
  computed: {
    apiUrl() {
      return process.env.VUE_APP_API_URL;
    },
    filteredPlayersForGoalScorer() {
      const players = this.availablePlayers || [];
      const q = (this.goalDialogScorerSearch || '').trim().toLowerCase();
      const filtered = !q
        ? [...players]
        : players.filter((p) => (p.last_name || '').toLowerCase().includes(q));
      const selId = this.goalDialog.player_id;
      if (!selId) return filtered;
      const selected = players.find((p) => p.id === selId);
      if (!selected || filtered.some((p) => p.id === selId)) return filtered;
      return [selected, ...filtered];
    },
    filteredPlayersForGoalAssist() {
      const players = this.availablePlayers || [];
      const q = (this.goalDialogAssistSearch || '').trim().toLowerCase();
      const filtered = !q
        ? [...players]
        : players.filter((p) => (p.last_name || '').toLowerCase().includes(q));
      const selId = this.goalDialog.assist;
      if (!selId) return filtered;
      const selected = players.find((p) => p.id === selId);
      if (!selected || filtered.some((p) => p.id === selId)) return filtered;
      return [selected, ...filtered];
    }
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleString('cs-CZ', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'UTC'
      });
    },
    getTeamName(teamId) {
      const team = this.teams.find(t => t.id === teamId);
      return team ? team.name : 'Neznámý tým';
    },
    async login() {
      try {
        const response = await axios.post('/api/auth/login', this.loginForm);
        localStorage.setItem('token', response.data.token);
        this.isLoggedIn = true;
        this.loadData();
        this.loadNewsArticles();
      } catch (error) {
        console.error('Login error:', error);
        alert('Neplatné přihlašovací údaje');
      }
    },
    async loadData() {
      try {
        const [teamsRes, seasonsRes, sponsorsRes] = await Promise.all([
          axios.get('/api/teams'),
          axios.get('/api/seasons'),
          axios.get('/api/sponsors')
        ]);
        this.teams = teamsRes.data;
        this.seasons = seasonsRes.data;
        this.sponsors = sponsorsRes.data;

        if (!this.selectedResultsSeasonId && this.seasons.length > 0) {
          this.selectedResultsSeasonId = this.seasons[0].id;
        }

        await this.loadMatches(this.selectedResultsSeasonId);
        
        if (this.teams.length > 0) {
          this.selectedTeamId = this.teams[0].id;
          await this.loadPlayers(this.selectedTeamId);
        }
      } catch (error) {
        console.error('Error loading data:', error);
      }
    },
    async loadMatches(seasonId = this.selectedResultsSeasonId) {
      try {
        const params = {};
        if (seasonId) {
          params.season_id = seasonId;
        }
        const response = await axios.get('/api/matches', { params });
        this.matches = response.data;
      } catch (error) {
        console.error('Error loading matches:', error);
      }
    },
    async loadPlayers(teamId) {
      try {
        const response = await axios.get(`/api/teams/${teamId}/players?includeInactive=true`);
        this.players = response.data;
      } catch (error) {
        console.error('Error loading players:', error);
      }
    },
    async handleTeamSelect(teamId) {
      this.selectedTeamId = teamId;
      await this.loadPlayers(teamId);
    },
    async loadAvailableLogos() {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          console.error('No authentication token found');
          return;
        }
        const response = await axios.get('/api/admin/logos', {
          headers: { Authorization: `Bearer ${token}` }
        });
        this.availableLogos = response.data;
      } catch (error) {
        console.error('Error loading logos:', error);
        if (error.response && error.response.status === 401) {
          // If unauthorized, redirect to login
          this.isLoggedIn = false;
          localStorage.removeItem('token');
        }
      }
    },
    showLogoSelectionModal(mode) {
      this.logoSelectionMode = mode;
      this.selectedLogo = null;
      this.loadAvailableLogos();
      this.logoSelectionModal.show();
    },
    selectLogo(logo) {
      this.selectedLogo = logo;
    },
    confirmLogoSelection() {
      if (this.selectedLogo) {
        if (this.logoSelectionMode === 'new') {
          this.newTeam.logo = this.selectedLogo;  // Store just the filename
          this.newTeam.logoPreview = this.getLogoUrl(`/uploads/logos/${this.selectedLogo}`);
        } else {
          this.editTeam.logo = this.selectedLogo;  // Store just the filename
          this.editTeam.logoPreview = this.getLogoUrl(`/uploads/logos/${this.selectedLogo}`);
        }
      }
      this.logoSelectionModal.hide();
    },
    handleLogoUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.newTeam.logo = file;
        this.newTeam.logoPreview = URL.createObjectURL(file);
      }
    },
    handleEditLogoUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.editTeam.logo = file;
        this.editTeam.logoPreview = URL.createObjectURL(file);
      }
    },
    clearTeamLogo(mode) {
      if (mode === 'new') {
        this.newTeam.logo = null;
        this.newTeam.logoPreview = null;
      } else {
        this.editTeam.logo = null;
        this.editTeam.logoPreview = null;
      }
    },
    startEditTeam(team) {
      this.editTeamId = team.id;
      this.editTeam = { 
        name: team.name,
        logo: null,
        logoPreview: null
      };
    },
    cancelEditTeam() {
      this.editTeamId = null;
      this.editTeam = { 
        name: '', 
        logo: null,
        logoPreview: null 
      };
    },
    async saveEditTeam(id) {
      try {
        const formData = new FormData();
        formData.append('name', this.editTeam.name);
        if (this.editTeam.logo) {
          // If logo is a string (filename), it's an existing logo
          if (typeof this.editTeam.logo === 'string') {
            formData.append('logo_path', this.editTeam.logo);
          } else {
            // If logo is a File object, it's a new upload
          formData.append('logo', this.editTeam.logo);
          }
        }

        await axios.put(`/api/admin/teams/${id}`, formData, {
          headers: { 
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'multipart/form-data'
          }
        });
        this.editTeamId = null;
        this.editTeam = { name: '', logo: null, logoPreview: null };
        this.loadData();
      } catch (error) {
        console.error('Error editing team:', error);
        if (error.response && error.response.data && error.response.data.error) {
          alert(error.response.data.error);
        }
      }
    },
    startEditSponsor(sponsor) {
      this.editSponsorId = sponsor.id;
      this.editSponsor = { name: sponsor.name, logo: sponsor.logo, website: sponsor.website, description: sponsor.description };
    },
    cancelEditSponsor() {
      this.editSponsorId = null;
      this.editSponsor = { name: '', logo: '', website: '', description: '' };
    },
    async saveEditSponsor(id) {
      try {
        await axios.put(`/api/admin/sponsors/${id}`, this.editSponsor, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        this.editSponsorId = null;
        this.editSponsor = { name: '', logo: '', website: '', description: '' };
        this.loadData();
      } catch (error) {
        console.error('Error editing sponsor:', error);
      }
    },
    async deleteTeam(id) {
      if (!confirm('Opravdu chcete tento tým smazat?')) return;
      try {
        await axios.delete(`/api/admin/teams/${id}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        this.loadData();
      } catch (error) {
        console.error('Error deleting team:', error);
      }
    },
    async deleteSponsor(id) {
      if (!confirm('Opravdu chcete tohoto sponzora smazat?')) return;
      try {
        await axios.delete(`/api/admin/sponsors/${id}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        this.loadData();
      } catch (error) {
        console.error('Error deleting sponsor:', error);
      }
    },
    async deleteMatch(id) {
      if (!confirm('Opravdu chcete tento zápas smazat?')) return;
      try {
        await axios.delete(`/api/admin/matches/${id}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        this.loadData();
      } catch (error) {
        if (error.response && error.response.data && error.response.data.error) {
          alert(error.response.data.error);
        } else {
          console.error('Error deleting match:', error);
        }
      }
    },
    async addPlayer() {
      try {
        await axios.post('/api/admin/players', this.newPlayer, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        this.newPlayer = {
          team_id: '',
          first_name: '',
          last_name: '',
          jersey_number: '',
          position: 'Útočník',
          is_registered: true
        };
        this.loadData();
      } catch (error) {
        console.error('Error adding player:', error);
        if (error.response && error.response.data && error.response.data.error) {
          alert(error.response.data.error);
        }
      }
    },
    handleFileUpload(event) {
      this.bulkImport.file = event.target.files[0];
    },
    async importPlayers() {
      if (!this.bulkImport.file) return;
      
      const reader = new FileReader();
      reader.onload = async (e) => {
        const text = e.target.result;
        const rows = text.split('\n')
          .slice(1) // Skip header
          .filter(row => row.trim() !== ''); // Remove empty rows
        
        const players = rows.map(row => {
          const [first_name, last_name, jersey_number, position, is_registered] = row.split(',').map(field => field.trim());
          
          // Validate required fields
          if (!first_name || !last_name || !jersey_number || !position) {
            throw new Error(`Chybí povinné pole v řádku: ${row}`);
          }

          const parsedJerseyNumber = parseInt(jersey_number);
          if (isNaN(parsedJerseyNumber)) {
            throw new Error(`Neplatné číslo dresu v řádku: ${row}`);
          }

          return {
            first_name,
            last_name,
            jersey_number: parsedJerseyNumber,
            position,
            is_registered: is_registered ? is_registered.toLowerCase() === 'true' : true
          };
        });

        try {
          await axios.post('/api/admin/players/bulk', {
            team_id: this.bulkImport.team_id,
            players
          }, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
          });
          this.bulkImport.file = null;
          this.loadData();
        } catch (error) {
          console.error('Error importing players:', error);
          if (error.response && error.response.data && error.response.data.error) {
            alert(error.response.data.error);
          } else if (error.message) {
            alert(error.message);
          }
        }
      };
      reader.readAsText(this.bulkImport.file);
    },
    startEditPlayer(player) {
      this.editPlayerId = player.id;
      this.editPlayer = { ...player };
    },
    cancelEditPlayer() {
      this.editPlayerId = null;
      this.editPlayer = {
        team_id: '',
        first_name: '',
        last_name: '',
        jersey_number: '',
        position: '',
        is_registered: true,
        isFreeAgent: false,
        note: ''
      };
    },
    async saveEditPlayer(id) {
      try {
        await axios.put(`/api/admin/players/${id}`, this.editPlayer, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        this.editPlayerId = null;
        this.editPlayer = {
          team_id: '',
          first_name: '',
          last_name: '',
          jersey_number: '',
          position: '',
          is_registered: true,
          isFreeAgent: false,
          note: ''
        };
        this.loadData();
      } catch (error) {
        console.error('Error editing player:', error);
        if (error.response && error.response.data && error.response.data.error) {
          alert(error.response.data.error);
        }
      }
    },
    async deletePlayer(id) {
      if (!confirm('Opravdu chcete tohoto hráče deaktivovat?')) return;
      try {
        await axios.delete(`/api/admin/players/${id}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        this.loadData();
      } catch (error) {
        console.error('Error deactivating player:', error);
      }
    },
    async activatePlayer(id) {
      if (!confirm('Opravdu chcete tohoto hráče znovu aktivovat?')) return;
      try {
        await axios.put(`/api/admin/players/${id}/activate`, {}, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        this.loadData();
      } catch (error) {
        console.error('Error activating player:', error);
      }
    },
    async showAddResultForm(match) {
      this.selectedMatch = match;
      try {
        const [homePlayersRes, awayPlayersRes] = await Promise.all([
          axios.get(`/api/teams/${match.home_team_id}/players`),
          axios.get(`/api/teams/${match.away_team_id}/players`)
        ]);
        this.availablePlayers = [...homePlayersRes.data, ...awayPlayersRes.data];
        this.availableGoalies = this.availablePlayers.filter(p => p.position === 'Brankář');
        // Vždy načti existující góly a brankáře (pro editaci i zadání)
        const [goalsRes, goalieStatsRes] = await Promise.all([
          axios.get(`/api/matches/${match.id}/goals`),
          axios.get(`/api/matches/${match.id}/goalie-stats`)
        ]);
        this.newResult = {
          home_score: match.home_score ?? '',
          away_score: match.away_score ?? '',
          goals: goalsRes.data.map(g => ({
            player_id: g.player_id,
            assist: g.assists && g.assists.length > 0 ? g.assists[0] : '', // Store only first assist
          })),
          goalieStats: goalieStatsRes.data.map(gs => ({
            player_id: gs.player_id,
            shots_against: gs.shots_against,
            saves: gs.saves,
            goals_against: gs.goals_against,
            minutes_played: gs.minutes_played
          }))
        };
        const modal = new Modal(document.getElementById('addResultModal'));
        modal.show();
      } catch (error) {
        console.error('Error loading players:', error);
      }
    },
    showGoalDialog() {
      this.goalDialog = {
        player_id: '',
        assist: ''
      };
      this.goalDialogScorerSearch = '';
      this.goalDialogAssistSearch = '';
      const modal = new Modal(document.getElementById('goalDialog'));
      modal.show();
    },
    addGoalFromDialog() {
      console.log('Adding goal with data:', this.goalDialog);
      // Add goal with single assist
      const goalData = {
        player_id: this.goalDialog.player_id,
        assist: this.goalDialog.assist || ''
      };
      console.log('Processed goal data:', goalData);
      this.newResult.goals.push(goalData);
      const modal = Modal.getInstance(document.getElementById('goalDialog'));
      modal.hide();
    },
    showGoalieDialog() {
      this.goalieDialog = {
        player_id: '',
        shots_against: '',
        saves: '',
        goals_against: '',
        minutes_played: ''
      };
      const modal = new Modal(document.getElementById('goalieDialog'));
      modal.show();
    },
    addGoalieFromDialog() {
      this.newResult.goalieStats.push({ ...this.goalieDialog });
      const modal = Modal.getInstance(document.getElementById('goalieDialog'));
      modal.hide();
    },
    getPlayerName(playerId) {
      const player = this.availablePlayers.concat(this.availableGoalies).find(p => p.id === playerId);
      return player ? `${player.first_name} ${player.last_name}` : 'Neznámý hráč';
    },
    removeGoal(index) {
      this.newResult.goals.splice(index, 1);
    },
    removeGoalieStats(index) {
      this.newResult.goalieStats.splice(index, 1);
    },
    async addResult() {
      try {
        console.log('Submitting result with data:', this.newResult);
        
        // Update match result
        await axios.put(`/api/admin/matches/${this.selectedMatch.id}/result`, {
          home_score: this.newResult.home_score,
          away_score: this.newResult.away_score
        }, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });

        // Delete existing goals and goalie stats first
        await Promise.all([
          axios.delete(`/api/admin/matches/${this.selectedMatch.id}/goals`, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
          }),
          axios.delete(`/api/admin/matches/${this.selectedMatch.id}/goalie-stats`, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
          })
        ]);

        // Add new goals
        for (const goal of this.newResult.goals) {
          console.log('Processing goal:', goal);
          const player = this.availablePlayers.find(p => p.id === goal.player_id);
          goal.team_id = player.team_id;
          // Convert single assist to array for backend
          const goalData = {
            ...goal,
            assists: goal.assist ? [goal.assist] : []
          };
          console.log('Sending goal data to server:', goalData);
          await axios.post(`/api/admin/matches/${this.selectedMatch.id}/goals`, goalData, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
          });
        }

        // Add new goalie stats
        for (const stats of this.newResult.goalieStats) {
          const player = this.availableGoalies.find(p => p.id === stats.player_id);
          stats.team_id = player.team_id;
          await axios.post(`/api/admin/matches/${this.selectedMatch.id}/goalie-stats`, stats, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
          });
        }

        const modal = Modal.getInstance(document.getElementById('addResultModal'));
        modal.hide();
        await this.loadData();
      } catch (error) {
        console.error('Error adding result:', error);
      }
    },
    handleMatchesFileUpload(event) {
      this.bulkMatchImport.file = event.target.files[0];
    },
    async importMatches() {
      if (!this.bulkMatchImport.file || !this.bulkMatchImport.season_id) return;
      const reader = new FileReader();
      reader.onload = async (e) => {
        const text = e.target.result;
        const rows = text.split('\n')
          .slice(1) // Skip header
          .filter(row => row.trim() !== '');
        const matches = rows.map(row => {
          const [home_team, away_team, match_date, venue] = row.split(',').map(field => field.trim());
          if (!home_team || !away_team || !match_date) {
            throw new Error(`Chybí povinné pole v řádku: ${row}`);
          }
          return { home_team, away_team, match_date, venue };
        });
        try {
          const response = await axios.post('/api/admin/matches/bulk', {
            season_id: this.bulkMatchImport.season_id,
            matches,
            isPlayOff: this.bulkMatchImport.isPlayOff
          }, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
          });
          this.bulkMatchImport.file = null;
          this.bulkMatchImport.season_id = '';
          this.bulkMatchImport.isPlayOff = false;
          this.loadData();
          if (response.data && response.data.success) {
            alert(`Import úspěšný! Počet vložených zápasů: ${response.data.imported}`);
          } else if (response.data && response.data.error) {
            alert('Chyba při importu: ' + response.data.error);
          }
        } catch (error) {
          if (error.response && error.response.data && error.response.data.error) {
            alert('Chyba při importu: ' + error.response.data.error + (typeof error.response.data.imported === 'number' ? `\nÚspěšně vloženo: ${error.response.data.imported}` : ''));
          } else if (error.message) {
            alert(error.message);
          }
        }
      };
      reader.readAsText(this.bulkMatchImport.file);
    },
    downloadSampleMatchesCsv() {
      const csv = `home_team,away_team,match_date,venue\nBlackbirds,Blackhawks,2024-10-01 18:00,Zimni stadion\nTigers,Wolves,2024-10-02 19:30,Arena Brno\nEagles,Panthers,2024-10-03 17:45,Hala Ostrava\n`;
      const blob = new Blob([csv], { type: 'text/csv' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'matches_sample.csv';
      a.click();
      URL.revokeObjectURL(url);
    },
    triggerFileInput(mode, teamId = null) {
      if (mode === 'new') {
        const input = this.$refs.teamLogoInput;
        if (input && typeof input.click === 'function') {
          input.click();
        } else {
          console.error('File input ref "teamLogoInput" not found or click method not available');
        }
      } else {
        const input = this.editTeamLogoInputs[teamId];
        if (input && typeof input.click === 'function') {
          input.click();
        } else {
          console.error(`File input ref for team ${teamId} not found or click method not available`);
        }
      }
    },
    async deleteTeamLogo(teamId) {
      if (!confirm('Opravdu chcete odstranit logo tohoto týmu?')) return;
      try {
        await axios.delete(`/api/admin/teams/${teamId}/logo`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        this.editTeam.logo = null;
        this.editTeam.logoPreview = null;
        this.loadData();
      } catch (error) {
        alert('Chyba při mazání loga týmu.');
        console.error('Error deleting team logo:', error);
      }
    },
    getLogoUrl(logoPath) {
      if (!logoPath) return '';
      // Pokud je logoPath už absolutní URL, vrať ji
      if (logoPath.startsWith('http')) return logoPath;
      // Jinak přidej apiUrl
      return `${this.apiUrl}${logoPath}`;
    },
    async addTeam() {
      try {
        const formData = new FormData();
        formData.append('name', this.newTeam.name);
        if (this.newTeam.logo) {
          // If logo is a string (filename), it's an existing logo
          if (typeof this.newTeam.logo === 'string') {
            formData.append('logo_path', this.newTeam.logo);
          } else {
            // If logo is a File object, it's a new upload
            formData.append('logo', this.newTeam.logo);
          }
        }

        await axios.post('/api/admin/teams', formData, {
          headers: { 
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'multipart/form-data'
          }
        });

        // Reset form
        this.newTeam = {
          name: '',
          logo: null,
          logoPreview: null
        };

        // Reload data
        await this.loadData();
      } catch (error) {
        console.error('Error adding team:', error);
        if (error.response && error.response.data && error.response.data.error) {
          alert(error.response.data.error);
        }
      }
    },
    startEditMatch(match) {
      this.editMatchId = match.id;
      this.editMatch = { 
        season_id: match.season_id,
        home_team_id: match.home_team_id,
        away_team_id: match.away_team_id,
        match_date: this.formatDateForInput(match.match_date),
        venue: match.venue,
        status: match.status,
        home_score: match.home_score,
        away_score: match.away_score,
        isPlayOff: match.isPlayOff || false
      };
    },
    cancelEditMatch() {
      this.editMatchId = null;
      this.editMatch = {
        season_id: '',
        home_team_id: '',
        away_team_id: '',
        match_date: '',
        venue: '',
        status: '',
        home_score: '',
        away_score: '',
        isPlayOff: false
      };
    },
    async saveEditMatch(matchId) {
      try {
        await axios.put(`/api/admin/matches/${matchId}`, this.editMatch, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        this.editMatchId = null;
        this.editMatch = {
          season_id: '',
          home_team_id: '',
          away_team_id: '',
          match_date: '',
          venue: '',
          status: '',
          home_score: '',
          away_score: '',
          isPlayOff: false
        };
        await this.loadData();
      } catch (error) {
        console.error('Error editing match:', error);
        if (error.response && error.response.data && error.response.data.error) {
          alert(error.response.data.error);
        }
      }
    },
    formatDateForInput(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toISOString().slice(0, 16); // Format: YYYY-MM-DDTHH:mm
    },
    async addMatch() {
      try {
        await axios.post('/api/admin/matches', this.newMatch, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        
        // Set success message
        this.successMessage = 'Zápas byl úspěšně přidán!';
        
        // Clear success message after 3 seconds
        setTimeout(() => {
          this.successMessage = '';
        }, 3000);
        
        // Reset form
        this.newMatch = {
          season_id: '',
          home_team_id: '',
          away_team_id: '',
          match_date: '',
          venue: '',
          isPlayOff: false
        };
        
        // Reload data
        await this.loadData();
      } catch (error) {
        console.error('Error adding match:', error);
        if (error.response && error.response.data && error.response.data.error) {
          alert(error.response.data.error);
        }
      }
    },
    async addSeason() {
      try {
        await axios.post('/api/admin/seasons', this.newSeason, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        
        // Set success message
        this.successMessage = 'Ročník byl úspěšně přidán!';
        
        // Clear success message after 3 seconds
        setTimeout(() => {
          this.successMessage = '';
        }, 3000);
        
        // Reset form
        this.newSeason = {
          name: '',
          start_date: '',
          end_date: ''
        };
        
        // Reload data
        await this.loadData();
      } catch (error) {
        console.error('Error adding season:', error);
        if (error.response && error.response.data && error.response.data.error) {
          alert(error.response.data.error);
        }
      }
    },
    async showTransferDialog(player) {
      this.transferData.new_team_id = '';
      this.transferData.new_jersey_number = '';
      this.selectedMatch = player;
      const modal = new Modal(document.getElementById('transferModal'));
      modal.show();
    },
    async transferPlayer() {
      try {
        await axios.post(`/api/admin/players/${this.selectedMatch.id}/transfer`, this.transferData, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        
        // Set success message
        this.successMessage = 'Hráč byl úspěšně přestoupil do nového týmu!';
        
        // Clear success message after 3 seconds
        setTimeout(() => {
          this.successMessage = '';
        }, 3000);
        
        const modal = Modal.getInstance(document.getElementById('transferModal'));
        modal.hide();
        await this.loadData();
      } catch (error) {
        console.error('Error transferring player:', error);
        if (error.response && error.response.data && error.response.data.error) {
          alert(error.response.data.error);
        }
      }
    },
    logout() {
      localStorage.removeItem('token');
      this.isLoggedIn = false;
      // Optional: window.location.href = '/';
    },
    async addDKMember() {
      try {
        const response = await axios.post('/api/admin/dk/members', this.newDKMember, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        this.dkMembers.push(response.data);
        this.newDKMember = { team_id: '', player_id: '' };
        await this.loadDKMembers();
      } catch (error) {
        console.error('Error adding DK member:', error);
        if (error.response && error.response.data && error.response.data.error) {
          alert(error.response.data.error);
        }
      }
    },
    async loadDKMembers() {
      try {
        const response = await axios.get('/api/admin/dk/members', {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        this.dkMembers = response.data;
        this.dkAvailablePlayers = this.dkMembers.map(member => ({
          ...member,
          team_name: this.getTeamName(member.team_id)
        }));
      } catch (error) {
        console.error('Error loading DK members:', error);
        if (error.response && error.response.data && error.response.data.error) {
          alert(error.response.data.error);
        }
      }
    },
    removeDKMember(id) {
      this.dkMembers = this.dkMembers.filter(member => member.id !== id);
      this.loadDKMembers();
    },
    async addDKMessage() {
      try {
        const response = await axios.post('/api/admin/dk/messages', this.newDKMessage, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        this.dkMessages.push(response.data);
        this.newDKMessage = { title: '', message: '', is_published: true };
        await this.loadDKMessages();
      } catch (error) {
        console.error('Error adding DK message:', error);
        if (error.response && error.response.data && error.response.data.error) {
          alert(error.response.data.error);
        }
      }
    },
    async loadDKMessages() {
      try {
        const response = await axios.get('/api/admin/dk-messages', {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        this.dkMessages = response.data;
      } catch (error) {
        console.error('Error loading DK messages:', error);
        if (error.response && error.response.data && error.response.data.error) {
          alert(error.response.data.error);
        }
      }
    },
    async deleteDKMessage(id) {
      if (!confirm('Opravdu chcete smazat tuto zprávu?')) return;
      try {
        await axios.delete(`/api/admin/dk/messages/${id}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        await this.loadDKMessages();
      } catch (error) {
        console.error('Error deleting DK message:', error);
        if (error.response && error.response.data && error.response.data.error) {
          alert(error.response.data.error);
        }
      }
    },
    editDKMessage(message) {
      this.editingDKMessage = { ...message };
      const modal = new Modal(document.getElementById('editMessageModal'));
      modal.show();
    },
    async updateDKMessage() {
      try {
        await axios.put(`/api/admin/dk/messages/${this.editingDKMessage.id}`, this.editingDKMessage, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        const modal = Modal.getInstance(document.getElementById('editMessageModal'));
        modal.hide();
        await this.loadDKMessages();
      } catch (error) {
        console.error('Error updating DK message:', error);
        if (error.response && error.response.data && error.response.data.error) {
          alert(error.response.data.error);
        }
      }
    },
    async loadNewsArticles() {
      const token = localStorage.getItem('token');
      if (!token) return;
      try {
        const response = await axios.get('/api/admin/news', {
          headers: { Authorization: `Bearer ${token}` }
        });
        this.newsArticles = response.data;
      } catch (error) {
        console.error('Error loading news:', error);
        if (error.response && error.response.data && error.response.data.error) {
          alert(error.response.data.error);
        }
      }
    },
    formatNewsArticleDate(iso) {
      if (!iso) return '';
      return new Date(iso).toLocaleString('cs-CZ', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    toDatetimeLocalValue(iso) {
      if (!iso) return '';
      const d = new Date(iso);
      if (Number.isNaN(d.getTime())) return '';
      const pad = (n) => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    onNewsCoverFileChange(event, target) {
      const file = event.target.files && event.target.files[0];
      if (target === 'new') {
        if (this.newsNewCoverPreviewUrl) {
          URL.revokeObjectURL(this.newsNewCoverPreviewUrl);
          this.newsNewCoverPreviewUrl = null;
        }
        this.newsNewCoverFile = file || null;
        this.newsNewCoverPreviewUrl = file ? URL.createObjectURL(file) : null;
      } else {
        if (this.editingNewsCoverPreviewUrl) {
          URL.revokeObjectURL(this.editingNewsCoverPreviewUrl);
          this.editingNewsCoverPreviewUrl = null;
        }
        this.editingNewsCoverFile = file || null;
        this.editingNewsCoverPreviewUrl = file ? URL.createObjectURL(file) : null;
      }
    },
    async addNewsArticle() {
      try {
        const token = localStorage.getItem('token');
        if (this.newsNewCoverFile) {
          const fd = new FormData();
          fd.append('title', this.newNewsArticle.title);
          fd.append('excerpt', this.newNewsArticle.excerpt || '');
          fd.append('content', this.newNewsArticle.content);
          fd.append('author', this.newNewsArticle.author || '');
          if (this.newNewsArticle.published_at && String(this.newNewsArticle.published_at).trim() !== '') {
            fd.append('published_at', this.newNewsArticle.published_at);
          }
          fd.append('is_published', this.newNewsArticle.is_published ? 'true' : 'false');
          fd.append('cover', this.newsNewCoverFile);
          await axios.post('/api/admin/news', fd, {
            headers: { Authorization: `Bearer ${token}` }
          });
        } else {
          const payload = { ...this.newNewsArticle };
          if (!payload.published_at || String(payload.published_at).trim() === '') {
            delete payload.published_at;
          }
          await axios.post('/api/admin/news', payload, {
            headers: { Authorization: `Bearer ${token}` }
          });
        }
        this.newsNewCoverFile = null;
        if (this.newsNewCoverPreviewUrl) {
          URL.revokeObjectURL(this.newsNewCoverPreviewUrl);
          this.newsNewCoverPreviewUrl = null;
        }
        if (this.$refs.newsNewCoverInput) {
          this.$refs.newsNewCoverInput.value = '';
        }
        this.newNewsArticle = {
          title: '',
          excerpt: '',
          content: '',
          author: '',
          published_at: '',
          is_published: true,
          cover_image: ''
        };
        await this.loadNewsArticles();
      } catch (error) {
        console.error('Error adding news article:', error);
        const msg = error.response && error.response.data && error.response.data.error
          ? error.response.data.error
          : 'Chyba při ukládání článku.';
        alert(msg);
      }
    },
    openEditNewsModal(article) {
      this.editingNewsCoverFile = null;
      this.removeNewsCover = false;
      this.editingNewsHadBlob = !!article.has_uploaded_cover;
      if (this.editingNewsCoverPreviewUrl) {
        URL.revokeObjectURL(this.editingNewsCoverPreviewUrl);
        this.editingNewsCoverPreviewUrl = null;
      }
      if (this.$refs.newsEditCoverInput) {
        this.$refs.newsEditCoverInput.value = '';
      }
      this.editingNewsArticle = {
        id: article.id,
        title: article.title,
        excerpt: article.excerpt || '',
        content: article.content,
        author: article.author || '',
        published_at: this.toDatetimeLocalValue(article.published_at),
        is_published: article.is_published !== false,
        cover_image: article.cover_image || ''
      };
      const modal = new Modal(document.getElementById('editNewsModal'));
      modal.show();
    },
    async updateNewsArticle() {
      try {
        const id = this.editingNewsArticle.id;
        const token = localStorage.getItem('token');
        if (this.editingNewsCoverFile) {
          const fd = new FormData();
          fd.append('title', this.editingNewsArticle.title);
          fd.append('excerpt', this.editingNewsArticle.excerpt || '');
          fd.append('content', this.editingNewsArticle.content);
          fd.append('author', this.editingNewsArticle.author || '');
          if (this.editingNewsArticle.published_at && String(this.editingNewsArticle.published_at).trim() !== '') {
            fd.append('published_at', this.editingNewsArticle.published_at);
          }
          fd.append('is_published', this.editingNewsArticle.is_published ? 'true' : 'false');
          fd.append('preserve_cover', 'false');
          fd.append('remove_cover', 'false');
          fd.append('cover', this.editingNewsCoverFile);
          await axios.put(`/api/admin/news/${id}`, fd, {
            headers: { Authorization: `Bearer ${token}` }
          });
        } else {
          const urlTrim = this.editingNewsArticle.cover_image && String(this.editingNewsArticle.cover_image).trim();
          const payload = {
            title: this.editingNewsArticle.title,
            excerpt: this.editingNewsArticle.excerpt,
            content: this.editingNewsArticle.content,
            author: this.editingNewsArticle.author,
            published_at: this.editingNewsArticle.published_at,
            is_published: this.editingNewsArticle.is_published,
            cover_image: this.editingNewsArticle.cover_image,
            remove_cover: this.removeNewsCover,
            preserve_cover:
              this.editingNewsHadBlob &&
              !this.removeNewsCover &&
              !urlTrim
          };
          await axios.put(`/api/admin/news/${id}`, payload, {
            headers: { Authorization: `Bearer ${token}` }
          });
        }
        this.editingNewsCoverFile = null;
        if (this.editingNewsCoverPreviewUrl) {
          URL.revokeObjectURL(this.editingNewsCoverPreviewUrl);
          this.editingNewsCoverPreviewUrl = null;
        }
        if (this.$refs.newsEditCoverInput) {
          this.$refs.newsEditCoverInput.value = '';
        }
        const modalEl = document.getElementById('editNewsModal');
        const modal = Modal.getInstance(modalEl);
        if (modal) modal.hide();
        await this.loadNewsArticles();
      } catch (error) {
        console.error('Error updating news article:', error);
        const msg = error.response && error.response.data && error.response.data.error
          ? error.response.data.error
          : 'Chyba při ukládání článku.';
        alert(msg);
      }
    },
    async deleteNewsArticle(id) {
      if (!confirm('Opravdu smazat tento článek?')) return;
      try {
        await axios.delete(`/api/admin/news/${id}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        await this.loadNewsArticles();
      } catch (error) {
        console.error('Error deleting news article:', error);
        const msg = error.response && error.response.data && error.response.data.error
          ? error.response.data.error
          : 'Chyba při mazání.';
        alert(msg);
      }
    },
    showUploadRecordModal(match) {
      this.recordUploadMatch = match;
      this.uploadRecordError = '';
      this.uploadingRecord = false;
      this.$nextTick(() => {
        this.$refs.recordInput && (this.$refs.recordInput.value = '');
      });
      const modal = new Modal(document.getElementById('uploadRecordModal'));
      modal.show();
    },
    async uploadMatchRecord() {
      if (!this.recordUploadMatch) return;
      const fileInput = this.$refs.recordInput;
      if (!fileInput || !fileInput.files.length) return;
      const file = fileInput.files[0];
      const formData = new FormData();
      formData.append('record', file);
      this.uploadingRecord = true;
      this.uploadRecordError = '';
      try {
        await axios.post(`/api/admin/matches/${this.recordUploadMatch.id}/record`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        });
        this.uploadingRecord = false;
        const modal = Modal.getInstance(document.getElementById('uploadRecordModal'));
        modal.hide();
        await this.loadData();
      } catch (err) {
        this.uploadingRecord = false;
        this.uploadRecordError = err.response?.data?.error || 'Chyba při nahrávání zápisu.';
      }
    },
    showEditEventForm(match) {
      this.editEventMatch = match;
      this.editEventData = {
        match_date: match.match_date ? new Date(match.match_date).toISOString().slice(0, 16) : '',
        venue: match.venue || ''
      };
      const modal = new Modal(document.getElementById('editEventModal'));
      modal.show();
    },
    async saveEventChanges() {
      try {
        await axios.put(`/api/admin/matches/${this.editEventMatch.id}/event`, this.editEventData, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        
        const modal = Modal.getInstance(document.getElementById('editEventModal'));
        modal.hide();
        
        // Reload data to show updated information
        await this.loadData();
        
        // Show success message
        this.successMessage = 'Událost zápasu byla úspěšně upravena.';
        setTimeout(() => {
          this.successMessage = '';
        }, 3000);
      } catch (error) {
        console.error('Error updating event:', error);
        alert('Chyba při ukládání změn: ' + (error.response?.data?.error || error.message));
      }
    },
    cancelEditEvent() {
      const modal = Modal.getInstance(document.getElementById('editEventModal'));
      modal.hide();
      this.editEventMatch = null;
      this.editEventData = {
        match_date: '',
        venue: ''
      };
    },
    makeFreeAgent(player) {
      if (confirm(`Opravdu chcete udělat hráče ${player.first_name} ${player.last_name} volným hráčem? Tím se odstraní z týmu.`)) {
        this.makePlayerFreeAgent(player.id);
      }
    },
    async makePlayerFreeAgent(playerId) {
      try {
        const response = await axios.put(`/api/admin/players/${playerId}/free-agent`, {}, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        
        if (response.data.success) {
          this.successMessage = 'Hráč byl úspěšně označen jako volný hráč.';
          this.loadPlayers(); // Znovu načíst seznam hráčů
        }
      } catch (error) {
        console.error('Chyba při změně statusu hráče:', error);
        alert('Nepodařilo se změnit status hráče. Zkuste to prosím znovu.');
      }
    },
    async loadLeagueManagement() {
      try {
        const response = await axios.get('/api/league-management', {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        this.leagueManagement = response.data;
      } catch (error) {
        console.error('Error loading league management:', error);
        if (error.response && error.response.status === 401) {
          this.isLoggedIn = false;
          localStorage.removeItem('token');
        }
      }
    },
    async loadTeamManagers() {
      try {
        const response = await axios.get('/api/team-managers', {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        this.teamManagers = response.data;
      } catch (error) {
        console.error('Error loading team managers:', error);
        if (error.response && error.response.status === 401) {
          this.isLoggedIn = false;
          localStorage.removeItem('token');
        }
      }
    },
    showLeagueManagementDialog(member = null) {
      if (member) {
        this.editedLeagueManagement = { ...member };
      } else {
        this.editedLeagueManagement = {
          id: null,
          first_name: '',
          last_name: '',
          role: 'member'
        };
      }
      if (!this.leagueManagementModal) {
        this.leagueManagementModal = new Modal(document.getElementById('leagueManagementModal'));
      }
      this.leagueManagementModal.show();
    },
    showTeamManagerDialog(manager = null) {
      if (manager) {
        this.editedTeamManager = { ...manager };
      } else {
        this.editedTeamManager = {
          id: null,
          team_id: null,
          first_name: '',
          last_name: ''
        };
      }
      if (!this.teamManagerModal) {
        this.teamManagerModal = new Modal(document.getElementById('teamManagerModal'));
      }
      this.teamManagerModal.show();
    },
    async saveLeagueManagement() {
      try {
        if (this.editedLeagueManagement.id) {
          await axios.put(`/api/admin/league-management/${this.editedLeagueManagement.id}`, this.editedLeagueManagement, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
          });
        } else {
          await axios.post('/api/admin/league-management', this.editedLeagueManagement, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
          });
        }
        this.leagueManagementModal.hide();
        this.loadLeagueManagement();
        alert('Člen vedení byl úspěšně uložen.');
      } catch (error) {
        alert('Chyba při ukládání člena vedení.');
        console.error('Error saving league management:', error);
        if (error.response && error.response.status === 401) {
          this.isLoggedIn = false;
          localStorage.removeItem('token');
        }
      }
    },
    async saveTeamManager() {
      try {
        if (this.editedTeamManager.id) {
          await axios.put(`/api/admin/team-managers/${this.editedTeamManager.id}`, this.editedTeamManager, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
          });
        } else {
          await axios.post('/api/admin/team-managers', this.editedTeamManager, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
          });
        }
        this.teamManagerModal.hide();
        this.loadTeamManagers();
        alert('Vedoucí týmu byl úspěšně uložen.');
      } catch (error) {
        alert('Chyba při ukládání vedoucího týmu.');
        console.error('Error saving team manager:', error);
        if (error.response && error.response.status === 401) {
          this.isLoggedIn = false;
          localStorage.removeItem('token');
        }
      }
    },
    async deleteLeagueManagement(id) {
      if (confirm('Opravdu chcete smazat tohoto člena vedení?')) {
        try {
          await axios.delete(`/api/admin/league-management/${id}`, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
          });
          this.loadLeagueManagement();
          alert('Člen vedení byl úspěšně smazán.');
        } catch (error) {
          alert('Chyba při mazání člena vedení.');
          console.error('Error deleting league management:', error);
          if (error.response && error.response.status === 401) {
            this.isLoggedIn = false;
            localStorage.removeItem('token');
          }
        }
      }
    },
    async deleteTeamManager(id) {
      if (confirm('Opravdu chcete smazat tohoto vedoucího týmu?')) {
        try {
          await axios.delete(`/api/admin/team-managers/${id}`, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
          });
          this.loadTeamManagers();
          alert('Vedoucí týmu byl úspěšně smazán.');
        } catch (error) {
          alert('Chyba při mazání vedoucího týmu.');
          console.error('Error deleting team manager:', error);
          if (error.response && error.response.status === 401) {
            this.isLoggedIn = false;
            localStorage.removeItem('token');
          }
        }
      }
    },
    async addTeamManagerFromForm() {
      try {
        // Find the selected player to get their name
        const selectedPlayer = this.teamManagerAvailablePlayers.find(p => p.id === this.newTeamManager.player_id);
        if (!selectedPlayer) {
          alert('Prosím vyberte hráče.');
          return;
        }

        const teamManagerData = {
          team_id: this.newTeamManager.team_id,
          first_name: selectedPlayer.first_name,
          last_name: selectedPlayer.last_name
        };

        const response = await axios.post('/api/admin/team-managers', teamManagerData, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        this.teamManagers.push(response.data);
        this.newTeamManager = { team_id: '', player_id: '' };
        this.teamManagerAvailablePlayers = [];
        await this.loadTeamManagers();
        alert('Vedoucí týmu byl úspěšně přidán.');
      } catch (error) {
        console.error('Error adding team manager:', error);
        if (error.response && error.response.data && error.response.data.error) {
          alert(error.response.data.error);
        }
      }
    },
    async loadTeamPlayers() {
      try {
        const response = await axios.get(`/api/teams/${this.newTeamManager.team_id}/players`);
        this.teamManagerAvailablePlayers = response.data;
      } catch (error) {
        console.error('Error loading team players:', error);
        this.teamManagerAvailablePlayers = [];
      }
    },
    async addLeagueManagementFromForm() {
      try {
        // Find the selected player to get their name
        const selectedPlayer = this.leagueManagementAvailablePlayers.find(p => p.id === this.newLeagueManagement.player_id);
        if (!selectedPlayer) {
          alert('Prosím vyberte hráče.');
          return;
        }

        const leagueManagementData = {
          first_name: selectedPlayer.first_name,
          last_name: selectedPlayer.last_name,
          role: 'member' // Always set as 'member' for team-based selection
        };

        const response = await axios.post('/api/admin/league-management', leagueManagementData, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        this.leagueManagement.push(response.data);
        this.newLeagueManagement = { team_id: '', player_id: '' };
        this.leagueManagementAvailablePlayers = [];
        await this.loadLeagueManagement();
        alert('Člen vedení byl úspěšně přidán.');
      } catch (error) {
        console.error('Error adding league management:', error);
        if (error.response && error.response.data && error.response.data.error) {
          alert(error.response.data.error);
        }
      }
    },
    async loadLeagueManagementAvailablePlayers() {
      try {
        const response = await axios.get('/api/league-management/available-players', {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        this.leagueManagementAvailablePlayers = response.data;
      } catch (error) {
        console.error('Error loading league management available players:', error);
        this.leagueManagementAvailablePlayers = [];
      }
    },
    async addSponsor() {
      try {
        await axios.post('/api/admin/sponsors', this.newSponsor, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        
        // Set success message
        this.successMessage = 'Sponzor byl úspěšně přidán!';
        
        // Clear success message after 3 seconds
        setTimeout(() => {
          this.successMessage = '';
        }, 3000);
        
        // Reset form
        this.newSponsor = {
          name: '',
          logo: '',
          website: '',
          description: ''
        };
        
        // Reload data
        await this.loadData();
      } catch (error) {
        console.error('Error adding sponsor:', error);
        if (error.response && error.response.data && error.response.data.error) {
          alert(error.response.data.error);
        }
      }
    },
    async loadPlayoffBracket() {
      if (!this.playoffBracketSeason) {
        this.playoffBracket = [];
        return;
      }
      try {
        const response = await axios.get('/api/admin/playoff-bracket', {
          params: { season_id: this.playoffBracketSeason },
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        this.playoffBracket = response.data.map(match => ({
          ...match,
          selectedWinner: match.winner_id || ''
        }));
      } catch (error) {
        console.error('Error loading playoff bracket:', error);
        if (error.response && error.response.status === 401) {
          this.isLoggedIn = false;
          localStorage.removeItem('token');
        }
      }
    },
    async addPlayoffBracketMatch() {
      if (!this.playoffBracketSeason) {
        alert('Nejdříve vyberte ročník');
        return;
      }
      if (!this.newPlayoffMatch.team1_id || !this.newPlayoffMatch.team2_id) {
        alert('Vyberte oba týmy');
        return;
      }
      try {
        await axios.post('/api/admin/playoff-bracket', {
          season_id: this.playoffBracketSeason,
          round: parseInt(this.newPlayoffMatch.round),
          match_number: parseInt(this.newPlayoffMatch.match_number),
          team1_id: this.newPlayoffMatch.team1_id,
          team2_id: this.newPlayoffMatch.team2_id
        }, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        
        // Reset form but keep season and increment match_number
        this.newPlayoffMatch = {
          season_id: '',
          round: this.newPlayoffMatch.round,
          match_number: parseInt(this.newPlayoffMatch.match_number) + 1,
          team1_id: '',
          team2_id: ''
        };
        
        await this.loadPlayoffBracket();
        this.successMessage = 'Zápas byl úspěšně přidán do pavouka!';
        setTimeout(() => { this.successMessage = ''; }, 3000);
      } catch (error) {
        console.error('Error adding playoff match:', error);
        if (error.response && error.response.data && error.response.data.error) {
          alert(error.response.data.error);
        }
      }
    },
    async setPlayoffWinner(match) {
      if (!match.selectedWinner) return;
      try {
        await axios.put(`/api/admin/playoff-bracket/${match.id}`, {
          winner_id: match.selectedWinner
        }, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        await this.loadPlayoffBracket();
      } catch (error) {
        console.error('Error setting winner:', error);
        if (error.response && error.response.data && error.response.data.error) {
          alert(error.response.data.error);
        }
      }
    },
    async deletePlayoffMatch(id) {
      if (!confirm('Opravdu chcete smazat tento zápas z pavouka?')) return;
      try {
        await axios.delete(`/api/admin/playoff-bracket/${id}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        await this.loadPlayoffBracket();
      } catch (error) {
        console.error('Error deleting playoff match:', error);
        if (error.response && error.response.data && error.response.data.error) {
          alert(error.response.data.error);
        }
      }
    },
    getUniqueRounds() {
      const rounds = [...new Set(this.playoffBracket.map(m => m.round))];
      return rounds.sort((a, b) => a - b);
    },
    getMatchesByRound(round) {
      return this.playoffBracket
        .filter(m => m.round === round)
        .sort((a, b) => a.match_number - b.match_number);
    }
  },
  mounted() {
    const token = localStorage.getItem('token');
    if (token) {
      this.isLoggedIn = true;
      this.loadData();
    }
    this.logoSelectionModal = new Modal(document.getElementById('logoSelectionModal'));
    // Ensure refs are available after component is mounted
    this.$nextTick(() => {
      if (!this.$refs.teamLogoInput || !this.$refs.editTeamLogoInput) {
        console.warn('File input refs not found after component mount');
      }
    });
    this.loadDKMembers();
    this.loadDKMessages();
    this.loadLeagueManagement();
    this.loadTeamManagers();
    this.loadLeagueManagementAvailablePlayers();
    if (token) {
      this.loadNewsArticles();
    }
  },
  watch: {
    activeTab(newVal) {
      if (newVal === 'news') {
        this.loadNewsArticles();
      }
    },
    dkTab(newVal) {
      if (newVal === 'messages') {
        this.loadDKMessages();
      }
    },
    'newDKMember.team_id': async function(newTeamId) {
      if (newTeamId) {
        try {
          const response = await axios.get(`/api/teams/${newTeamId}/players`);
          this.dkAvailablePlayers = response.data;
        } catch (error) {
          console.error('Chyba při načítání hráčů týmu:', error);
          this.dkAvailablePlayers = [];
        }
      } else {
        this.dkAvailablePlayers = [];
      }
    },
    'newTeamManager.team_id': async function(newTeamId) {
      if (newTeamId) {
        try {
          const response = await axios.get(`/api/teams/${newTeamId}/players`);
          this.teamManagerAvailablePlayers = response.data;
        } catch (error) {
          console.error('Error loading team players:', error);
          this.teamManagerAvailablePlayers = [];
        }
      } else {
        this.teamManagerAvailablePlayers = [];
      }
    },
    'newLeagueManagement.team_id': async function(newTeamId) {
      if (newTeamId) {
        try {
          const response = await axios.get(`/api/teams/${newTeamId}/players`);
          this.leagueManagementAvailablePlayers = response.data;
        } catch (error) {
          console.error('Error loading league management available players:', error);
          this.leagueManagementAvailablePlayers = [];
        }
      } else {
        this.leagueManagementAvailablePlayers = [];
      }
    }
  }
}
</script>

<style scoped>
/* ═══════════════════════════════════════════
   NHL Liga Admin — Modern Dark UI
   ═══════════════════════════════════════════ */

.admin-page {
  max-width: 1200px;
  margin: 0 auto;
  background: #0a1023;
  color: #e0e6f7;
  min-height: 100vh;
  padding: 2rem 1rem 3rem;
}

/* ── Login ── */
.login-form {
  max-width: 420px;
  margin: 4rem auto;
  background: rgba(21, 29, 58, 0.85);
  backdrop-filter: blur(16px) saturate(1.6);
  -webkit-backdrop-filter: blur(16px) saturate(1.6);
  color: #e0e6f7;
  border-radius: 1rem;
  border: 1px solid rgba(31, 224, 255, 0.1);
  box-shadow: 0 8px 32px rgba(10, 16, 35, 0.6),
              0 0 0 1px rgba(31, 224, 255, 0.05);
  padding: 2.5rem 2rem 2rem;
}

.login-form h2 {
  text-align: center;
  margin-bottom: 2rem;
}

/* ── Headings ── */
h2 {
  background: linear-gradient(135deg, #1fe0ff, #0a7cff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1.15;
  font-size: 1.75rem;
  margin-bottom: 1.5rem;
}

h3 {
  color: #e0e6f7;
  font-weight: 700;
  font-size: 1.25rem;
  letter-spacing: -0.01em;
  margin-bottom: 1.2rem;
  margin-top: 0.5rem;
}

h4 {
  color: #8892b0;
  font-weight: 600;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 1rem;
}

h5, .modal-title {
  color: #e0e6f7;
  font-weight: 700;
  font-size: 1.1rem;
}

h6 {
  color: #8892b0;
  font-weight: 600;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 0.75rem;
}

/* ── Tab Pills ── */
.nav-tabs {
  border-bottom: none;
  gap: 0.5rem;
  padding-bottom: 1rem;
  flex-wrap: wrap;
}

.nav-tabs .nav-link {
  color: #8892b0;
  background: transparent;
  border: 1px solid rgba(31, 224, 255, 0.13);
  border-radius: 999px;
  padding: 0.45rem 1.15rem;
  font-weight: 600;
  font-size: 0.88rem;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  margin-right: 0;
  white-space: nowrap;
}

.nav-tabs .nav-link:hover {
  color: #1fe0ff;
  border-color: rgba(31, 224, 255, 0.3);
  background: rgba(31, 224, 255, 0.05);
}

.nav-tabs .nav-link.active {
  background: linear-gradient(135deg, #1fe0ff, #0a7cff);
  color: #0a1023 !important;
  font-weight: 700;
  border: none;
  box-shadow: 0 4px 20px rgba(31, 224, 255, 0.25);
}

/* ── Tab Content Panel ── */
.tab-content {
  padding: 1.75rem;
  background: #151d3a;
  border-radius: 1rem;
  border: 1px solid rgba(31, 224, 255, 0.08);
}

/* ── Tables ── */
.table {
  background: transparent;
  color: #e0e6f7;
  border-radius: 0.75rem;
  overflow: hidden;
  margin-bottom: 1.5rem;
  border-collapse: separate;
  border-spacing: 0;
}

.table thead th {
  background: rgba(31, 224, 255, 0.06);
  color: #1fe0ff;
  font-weight: 600;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  border: none;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid rgba(31, 224, 255, 0.1);
}

.table td, .table th {
  border: none;
  padding: 0.7rem 1rem;
  vertical-align: middle;
}

.table td {
  border-bottom: 1px solid rgba(31, 224, 255, 0.04);
}

.table tbody tr {
  transition: background 0.2s ease;
}

.table tbody tr:hover {
  background: rgba(31, 224, 255, 0.03);
}

.table-bordered {
  border: 1px solid rgba(31, 224, 255, 0.1);
}

.table-bordered th,
.table-bordered td {
  border-color: rgba(31, 224, 255, 0.08);
}

.table-striped tbody tr:nth-of-type(odd) {
  background: rgba(31, 224, 255, 0.02);
}

/* ── Form Controls ── */
.form-control, .form-select {
  background: #0a1023;
  color: #e0e6f7;
  border: 1px solid rgba(31, 224, 255, 0.13);
  border-radius: 0.5rem;
  padding: 0.6rem 0.85rem;
  font-size: 0.95rem;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.form-control:focus, .form-select:focus {
  background: #0a1023;
  color: #e0e6f7;
  border-color: #1fe0ff;
  box-shadow: 0 0 0 3px rgba(31, 224, 255, 0.15);
  outline: none;
}

.form-control::placeholder {
  color: #555e7e;
}

.form-label {
  color: #8892b0;
  font-weight: 500;
  font-size: 0.9rem;
  margin-bottom: 0.35rem;
}

.form-text {
  color: #555e7e !important;
}

.form-check-label {
  color: #e0e6f7;
}

.form-check-input {
  background-color: #0a1023;
  border-color: rgba(31, 224, 255, 0.2);
}

.form-check-input:checked {
  background-color: #1fe0ff;
  border-color: #1fe0ff;
}

.form-check-input:focus {
  box-shadow: 0 0 0 3px rgba(31, 224, 255, 0.15);
}

input.form-control:disabled,
select.form-select:disabled {
  background: rgba(31, 224, 255, 0.04) !important;
  color: #8892b0 !important;
  opacity: 1 !important;
  border: 1px solid rgba(31, 224, 255, 0.06);
  border-radius: 0.5rem;
  box-shadow: none;
}

/* ── CTA / Primary Button ── */
.btn-primary {
  background: linear-gradient(135deg, #1fe0ff 0%, #0a7cff 100%);
  color: #0a1023;
  font-weight: 700;
  border: none;
  border-radius: 0.5rem;
  padding: 0.55rem 1.5rem;
  font-size: 0.95rem;
  box-shadow: 0 2px 8px rgba(31, 224, 255, 0.2);
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  letter-spacing: 0.01em;
}

.btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 20px rgba(31, 224, 255, 0.35);
  background: linear-gradient(135deg, #1fe0ff 0%, #0a7cff 100%);
  color: #0a1023;
}

/* ── Danger Button ── */
.btn-danger {
  background: rgba(255, 77, 106, 0.12);
  color: #ff4d6a;
  border: 1px solid rgba(255, 77, 106, 0.25);
  border-radius: 0.5rem;
  font-weight: 600;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-danger:hover {
  background: #ff4d6a;
  color: #0a1023;
  border-color: #ff4d6a;
}

/* ── Warning Button ── */
.btn-warning {
  background: rgba(255, 193, 7, 0.1);
  color: #ffc107;
  border: 1px solid rgba(255, 193, 7, 0.2);
  border-radius: 0.5rem;
  font-weight: 600;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-warning:hover {
  background: #ffc107;
  color: #0a1023;
  border-color: #ffc107;
}

/* ── Success Button ── */
.btn-success {
  background: rgba(52, 211, 153, 0.1);
  color: #34d399;
  border: 1px solid rgba(52, 211, 153, 0.2);
  border-radius: 0.5rem;
  font-weight: 600;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-success:hover {
  background: #34d399;
  color: #0a1023;
  border-color: #34d399;
}

/* ── Secondary Button ── */
.btn-secondary {
  background: rgba(136, 146, 176, 0.1);
  color: #8892b0;
  border: 1px solid rgba(136, 146, 176, 0.2);
  border-radius: 0.5rem;
  font-weight: 600;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-secondary:hover {
  background: rgba(136, 146, 176, 0.2);
  color: #e0e6f7;
}

/* ── Info Button ── */
.btn-info {
  background: rgba(31, 224, 255, 0.1);
  color: #1fe0ff;
  border: 1px solid rgba(31, 224, 255, 0.2);
  border-radius: 0.5rem;
  font-weight: 600;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-info:hover {
  background: rgba(31, 224, 255, 0.2);
  color: #1fe0ff;
}

/* ── Outline Buttons ── */
.btn-outline-light {
  color: #8892b0;
  border-color: rgba(136, 146, 176, 0.3);
  border-radius: 0.5rem;
  font-weight: 600;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-outline-light:hover {
  background: rgba(136, 146, 176, 0.1);
  color: #e0e6f7;
  border-color: rgba(136, 146, 176, 0.4);
}

.btn-outline-danger {
  color: #ff4d6a;
  border-color: rgba(255, 77, 106, 0.3);
  border-radius: 0.5rem;
  font-weight: 600;
}

.btn-outline-secondary {
  color: #8892b0;
  border-color: rgba(136, 146, 176, 0.3);
  border-radius: 0.5rem;
  font-weight: 600;
}

/* ── Small Buttons ── */
.btn-sm {
  padding: 0.3rem 0.85rem;
  font-size: 0.82rem;
  border-radius: 0.4rem;
}

/* ── Cards ── */
.card {
  background: #151d3a;
  border: 1px solid rgba(31, 224, 255, 0.08);
  border-radius: 0.75rem;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.card:hover {
  transform: translateY(-2px);
  border-color: rgba(31, 224, 255, 0.15);
  box-shadow: 0 8px 24px rgba(10, 16, 35, 0.4),
              0 0 0 1px rgba(31, 224, 255, 0.05);
}

.card-body {
  padding: 1.25rem;
}

.card-title {
  color: #e0e6f7 !important;
}

.card-text {
  color: #e0e6f7 !important;
}

/* ── Modals ── */
.modal-content {
  background: #151d3a;
  color: #e0e6f7;
  border: 1px solid rgba(31, 224, 255, 0.1);
  border-radius: 1rem;
  box-shadow: 0 16px 48px rgba(10, 16, 35, 0.7);
}

.modal-header {
  border-bottom: 1px solid rgba(31, 224, 255, 0.08);
  padding: 1.25rem 1.5rem;
}

.modal-body {
  padding: 1.5rem;
}

.modal-footer {
  border-top: 1px solid rgba(31, 224, 255, 0.08);
  padding: 1rem 1.5rem;
}

.btn-close {
  filter: invert(1) grayscale(100%) brightness(200%);
  opacity: 0.5;
}

.btn-close:hover {
  opacity: 0.9;
}

/* ── Alerts ── */
.alert-success {
  background: rgba(52, 211, 153, 0.1);
  color: #34d399;
  border: 1px solid rgba(52, 211, 153, 0.2);
  border-radius: 0.75rem;
}

.alert-success .btn-close {
  color: #34d399;
}

.alert-info {
  background: rgba(31, 224, 255, 0.08);
  color: #1fe0ff;
  border: 1px solid rgba(31, 224, 255, 0.15);
  border-radius: 0.75rem;
}

/* ── Badges ── */
.badge {
  font-weight: 600;
  font-size: 0.75rem;
  padding: 0.35em 0.7em;
  border-radius: 999px;
}

.badge.bg-primary {
  background: linear-gradient(135deg, #1fe0ff, #0a7cff) !important;
  color: #0a1023;
}

.badge.bg-info {
  background: rgba(31, 224, 255, 0.15) !important;
  color: #1fe0ff;
}

.badge.bg-success {
  background: rgba(52, 211, 153, 0.15) !important;
  color: #34d399;
}

.badge.bg-warning {
  background: rgba(255, 193, 7, 0.15) !important;
  color: #ffc107;
}

.badge.bg-danger {
  background: rgba(255, 77, 106, 0.15) !important;
  color: #ff4d6a;
}

.badge.bg-secondary {
  background: rgba(136, 146, 176, 0.15) !important;
  color: #8892b0;
}

/* ── Logo Items ── */
.logo-preview {
  background: rgba(31, 224, 255, 0.05);
  padding: 6px;
  border-radius: 0.5rem;
  border: 1px solid rgba(31, 224, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-item {
  cursor: pointer;
  padding: 12px;
  border-radius: 0.75rem;
  background: #0a1023;
  border: 1px solid rgba(31, 224, 255, 0.08);
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
}

.logo-item:hover {
  border-color: rgba(31, 224, 255, 0.25);
  background: rgba(31, 224, 255, 0.05);
  transform: translateY(-2px);
}

.logo-item.selected {
  background: rgba(31, 224, 255, 0.1);
  border-color: #1fe0ff;
  box-shadow: 0 0 16px rgba(31, 224, 255, 0.25);
}

.logo-item img {
  max-height: 80px;
  max-width: 100%;
  object-fit: contain;
}

/* ── Team Logos ── */
.team-logo {
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.team-logo-placeholder {
  width: 28px;
  height: 28px;
  background: rgba(136, 146, 176, 0.15);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ── DK Messages ── */
.dk-messages .dk-message {
  background: #151d3a;
  border: 1px solid rgba(31, 224, 255, 0.08);
}

/* ── Debug Pre Block ── */
pre {
  background: rgba(31, 224, 255, 0.05) !important;
  color: #1fe0ff !important;
  padding: 12px 16px !important;
  border-radius: 0.75rem !important;
  border: 1px solid rgba(31, 224, 255, 0.1) !important;
  font-size: 0.8rem;
  overflow-x: auto;
}

/* ── Utility Classes ── */
.text-dimmed {
  color: #8892b0;
}

/* ── Responsive ── */
@media (max-width: 768px) {
  .admin-page {
    padding: 1rem 0.5rem 2rem;
  }

  .nav-tabs {
    overflow-x: auto;
    flex-wrap: nowrap;
    padding-bottom: 0.75rem;
    scrollbar-width: none;
  }

  .nav-tabs::-webkit-scrollbar {
    display: none;
  }

  .tab-content {
    padding: 1rem;
    border-radius: 0.75rem;
  }
}
</style>